import React, { useState, useEffect, useContext, useMemo } from 'react';
import { AuthContext } from '../../../contexts/AuthContext';
import Header from '../../../layout/Header/Header';
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Input,
  Label,
  ButtonGroup,
  Col,
  Tooltip,
  UncontrolledTooltip
} from 'reactstrap';
import SweetAlert from 'sweetalert2-react';
import Swal from 'sweetalert2';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import autoTable from 'jspdf-autotable';
import ExportJsonExcel from 'js-export-excel';
import { encode } from 'base64-arraybuffer';
import axios from 'axios';
import { TableHeader, Pagination, Search } from '../../../DataTable';
import useFullPageLoader from '../../../hooks/useFullPageLoader';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { v4 as uuidv4 } from 'uuid';
import EtaUpdate from '../../EtaUpdate';
import Baja from '../../Baja';
// import { MapContainer, TileLayer, Marker, Polyline } from 'react-leaflet';
// import L from 'leaflet';

// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
// });

function ListadoContenedores() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_CONTENEDORES = process.env.REACT_APP_URL_CONTENEDORES;
  const URL_ARTICULOS_CONTENEDOR = process.env.REACT_APP_URL_ARTICULOS_CONTENEDOR;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_GASTOS_CONTENEDOR = process.env.REACT_APP_URL_GASTOS_CONTENEDOR;
  const URL_CARGOS_CONTENEDOR = process.env.REACT_APP_URL_CARGOS_CONTENEDOR;
  const URL_CONCEPTOS_GASTOS = process.env.REACT_APP_URL_CONCEPTOS_GASTOS;
  const URL_TERMINALES = process.env.REACT_APP_URL_TERMINALES;
  const URL_PROGRAMAS = process.env.REACT_APP_URL_PROGRAMAS;
  const URL_PATENTES = process.env.REACT_APP_URL_PATENTES;


  const URL_UPMEDIA_ATRACO = process.env.REACT_APP_URL_UPMEDIA_ATRACO;
  const URL_UPMEDIA_TOQUEPISO = process.env.REACT_APP_URL_UPMEDIA_TOQUEPISO;
  const URL_UPMEDIA_CARTAENCOMIENDA = process.env.REACT_APP_URL_UPMEDIA_CARTAENCOMIENDA;
  const URL_UPMEDIA_OTROSDOCUMENTOS = process.env.REACT_APP_URL_UPMEDIA_OTROSDOCUMENTOS;
  const URL_UPMEDIA_ARCHIVOPENDIENTES = process.env.REACT_APP_URL_UPMEDIA_ARCHIVOPENDIENTES;
  const URL_UPMEDIA_BLREVALIDADO = process.env.REACT_APP_URL_UPMEDIA_BLREVALIDADO;
  const URL_UPMEDIA_CLASIFICADO = process.env.REACT_APP_URL_UPMEDIA_CLASIFICADO;
  const URL_UPMEDIA_CARTA318 = process.env.REACT_APP_URL_UPMEDIA_CARTA318;
  const URL_UPMEDIA_PROFORMAPEDIMENTO = process.env.REACT_APP_URL_UPMEDIA_PROFORMAPEDIMENTO;


  const URL_UPMEDIA_PACKING = process.env.REACT_APP_URL_UPMEDIA_PACKING;
  const URL_UPMEDIA_BL = process.env.REACT_APP_URL_UPMEDIA_BL;
  const URL_UPMEDIA_INVOICE = process.env.REACT_APP_URL_UPMEDIA_INVOICE;
  const URL_UPMEDIA_FICHA_TECNICA = process.env.REACT_APP_URL_UPMEDIA_FICHA_TECNICA;
  const URL_UPMEDIA_CARGOS_LOCALES = process.env.REACT_APP_URL_UPMEDIA_CARGOS_LOCALES;
  const URL_UPMEDIA_DODA = process.env.REACT_APP_URL_UPMEDIA_DODA;
  const URL_UPMEDIA_BOLETA = process.env.REACT_APP_URL_UPMEDIA_BOLETA;
  const URL_UPMEDIA_PREALTA = process.env.REACT_APP_URL_UPMEDIA_PREALTA;
  const URL_UPMEDIA_EIR = process.env.REACT_APP_URL_UPMEDIA_EIR;
  const URL_UPMEDIA_VALIDACION = process.env.REACT_APP_URL_UPMEDIA_VALIDACION;
  const URL_UPMEDIA_GARANTIA = process.env.REACT_APP_URL_UPMEDIA_GARANTIA;
  const URL_UPMEDIA_TRANSPORTE = process.env.REACT_APP_URL_UPMEDIA_TRANSPORTE;
  const URL_DELMEDIA = process.env.REACT_APP_URL_DELMEDIA;

  const [t, i18n] = useTranslation('global');
  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 365);

  let comp30 = new Date();
  comp30.setDate(comp30.getDate() - 30);

  let endDate = moment(hoy).format('YYYY-MM-DD');
  let startDate = moment(inicio).format('YYYY-MM-DD');

  const [articulos, setArticulos] = useState([]);

  const [programas, setProgramas] = useState([]);
  const [patentes, setPatentes] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [terminales, setTerminales] = useState([]);
  const [selectedNaviera, setSelectedNaviera] = useState('');
  const [selectedTerminal, setSelectedTerminal] = useState('');
  const [selectedPrograma, setSelectedPrograma] = useState('');
  const [selectedPatente, setSelectedPatente] = useState('');
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState('');
  const [selectedAgente, setSelectedAgente] = useState('');
  const [selectedAgencia, setSelectedAgencia] = useState('');
  const [selectedComisionista, setSelectedComisionista] = useState('');
  const [selectedTransportista, setSelectedTransportista] = useState('');
  const [selectedForwarder, setSelectedForwarder] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedRevalidacion, setSelectedRevalidacion] = useState('');
  const [selectedPuerto, setSelectedPuerto] = useState('');
  const [selectedModalidad, setSelectedModalidad] = useState('');
  const [selectedAsegurado, setSelectedAsegurado] = useState('');
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [selectedFechaCitaInicio, setSelectedFechaCitaInicio] = useState("");
  const [selectedFechaCitaFin, setSelectedFechaCitaFin] = useState("");

  const [selectedPendiente, setSelectedPendiente] = useState('No');
  const [selectedActivo, setSelectedActivo] = useState('Si');

  const [fecha, setFecha] = useState('');
  const [fechaCita, setFechaCita] = useState('');
  const [numeroBl, setNumeroBl] = useState('');
  const [puerto, setPuerto] = useState('');
  const [puertoOrigen, setPuertoOrigen] = useState('');
  const [direccionEntrega, setDireccionEntrega] = useState('');
  const [observaciones, setObservaciones] = useState('NA');
  const [observacionesInternas, setObservacionesInternas] = useState('NA');
  const [totalGeneral, setTotalGeneral] = useState('');
  const [totalCantidad, setTotalCantidad] = useState('');
  const [numeroContenedor, setNumeroContenedor] = useState('');
  const [rastreo, setRastreo] = useState('No');
  const [pesoTotal, setPesoTotal] = useState(0);
  const [totalGastos, setTotalGastos] = useState(0);
  const [totalCargos, setTotalCargos] = useState(0);

    const [diasLibresDemoras, setDiasLibresDemoras] = useState(0);
    const [diasLibresAlmacenajes, setDiasLibresAlmacenajes] = useState(0);
    const [tamanoContenedor, setTamanoContenedor] = useState("NA");
    const [pesoContenedor, setPesoContenedor] = useState("NA");
    const [buque, setBuque] = useState("NA");
    const [regimen, setRegimen] = useState("NA");
    const [claveRegimen, setClaveRegimen] = useState("NA");
    const [recinto, setRecinto] = useState("NA");
    const [selloContenedor, setSelloContenedor] = useState("NA");
    const [referenciaPatente, setReferenciaPatente] = useState("NA");
    const [ejecutivo, setEjecutivo] = useState("NA");

  const [idEdit, setIdEdit] = useState('');
  const [selectedNavieraEdit, setSelectedNavieraEdit] = useState('');
  const [selectedClienteEdit, setSelectedClienteEdit] = useState('');
  const [selectedAgenteEdit, setSelectedAgenteEdit] = useState('');
  const [selectedAgenciaEdit, setSelectedAgenciaEdit] = useState('');
  const [selectedComisionistaEdit, setSelectedComisionistaEdit] = useState('');
  const [selectedTransportistaEdit, setSelectedTransportistaEdit] = useState('');
  const [selectedForwarderEdit, setSelectedForwarderEdit] = useState('');

  const [coordenadasMapa, setCoordenadasMapa] = useState([]);
  const [originCoords, setOriginCoords] = useState([]);
  const [destinationCoords, setDestinationCoords] = useState([]);
  const [vesselCoords, setVesselCoords] = useState([]);
  const [diasLlegada, setDiasLlegada] = useState(0);

  const [modalMapa, setModalMapa] = useState(false);
  const toggleMapa = () => setModalMapa(!modalMapa);

  const [numeroInterno, setnumeroInterno] = useState('');
  const [contenedor, setContenedor] = useState('');
  // const [fechaETAEstimada, setFechaETAEstimada] = useState("");
  const [fechaETAReal, setFechaETAReal] = useState('');

  const [articulosContenedor, setArticulosContenedor] = useState([]);
  const [modalEditArticulos, setModalEditArticulos] = useState(false);
  const toggleEditArticulos = () => setModalEditArticulos(!modalEditArticulos);
  const [totalGeneral_edit, setTotalGeneralEdit] = useState(0);
  const [totalCantidad_edit, setTotalCantidadEdit] = useState(0);

   const [modalSubirFotoAtraco, setModalSubirFotoAtraco] = useState(false);
  const toggleSubirFotoAtraco = () => setModalSubirFotoAtraco(!modalSubirFotoAtraco);
  const [modalFotoAtraco, setModalFotoAtraco] = useState(false);
  const toggleFotoAtraco = () => setModalFotoAtraco(!modalFotoAtraco);

   const [modalSubirFotoToquePiso, setModalSubirFotoToquePiso] = useState(false);
  const toggleSubirFotoToquePiso = () => setModalSubirFotoToquePiso(!modalSubirFotoToquePiso);
  const [modalFotoToquePiso, setModalFotoToquePiso] = useState(false);
  const toggleFotoToquePiso = () => setModalFotoToquePiso(!modalFotoToquePiso);

   const [modalSubirFotoCartaEncomienda, setModalSubirFotoCartaEncomienda] = useState(false);
  const toggleSubirFotoCartaEncomienda = () => setModalSubirFotoCartaEncomienda(!modalSubirFotoCartaEncomienda);
  const [modalFotoCartaEncomienda, setModalFotoCartaEncomienda] = useState(false);
  const toggleFotoCartaEncomienda = () => setModalFotoCartaEncomienda(!modalFotoCartaEncomienda);

  const [modalSubirFotoOtrosDocumentos, setModalSubirFotoOtrosDocumentos] = useState(false);
  const toggleSubirFotoOtrosDocumentos = () => setModalSubirFotoOtrosDocumentos(!modalSubirFotoOtrosDocumentos);
  const [modalFotoOtrosDocumentos, setModalFotoOtrosDocumentos] = useState(false);
  const toggleFotoOtrosDocumentos = () => setModalFotoOtrosDocumentos(!modalFotoOtrosDocumentos);

  const [modalSubirFotoArchivoPendientes, setModalSubirFotoArchivoPendientes] = useState(false);
  const toggleSubirFotoArchivoPendientes = () => setModalSubirFotoArchivoPendientes(!modalSubirFotoArchivoPendientes);
  const [modalFotoArchivoPendientes, setModalFotoArchivoPendientes] = useState(false);
  const toggleFotoArchivoPendientes = () => setModalFotoArchivoPendientes(!modalFotoArchivoPendientes);

  const [modalSubirFotoBLRevalidado, setModalSubirFotoBLRevalidado] = useState(false);
  const toggleSubirFotoBLRevalidado = () => setModalSubirFotoBLRevalidado(!modalSubirFotoBLRevalidado);
  const [modalFotoBLRevalidado, setModalFotoBLRevalidado] = useState(false);
  const toggleFotoBLRevalidado = () => setModalFotoBLRevalidado(!modalFotoBLRevalidado);

  const [modalSubirFotoClasificado, setModalSubirFotoClasificado] = useState(false);
  const toggleSubirFotoClasificado = () => setModalSubirFotoClasificado(!modalSubirFotoClasificado);
  const [modalFotoClasificado, setModalFotoClasificado] = useState(false);
  const toggleFotoClasificado = () => setModalFotoClasificado(!modalFotoClasificado);

  const [modalSubirFotoCarta318, setModalSubirFotoCarta318] = useState(false);
  const toggleSubirFotoCarta318 = () => setModalSubirFotoCarta318(!modalSubirFotoCarta318);
  const [modalFotoCarta318, setModalFotoCarta318] = useState(false);
  const toggleFotoCarta318 = () => setModalFotoCarta318(!modalFotoCarta318);

  const [modalSubirFotoProformaPedimento, setModalSubirFotoProformaPedimento] = useState(false);
  const toggleSubirFotoProformaPedimento = () => setModalSubirFotoProformaPedimento(!modalSubirFotoProformaPedimento);
  const [modalFotoProformaPedimento, setModalFotoProformaPedimento] = useState(false);
  const toggleFotoProformaPedimento = () => setModalFotoProformaPedimento(!modalFotoProformaPedimento);

  const [modalSubirFotoPacking, setModalSubirFotoPacking] = useState(false);
  const toggleSubirFotoPacking = () => setModalSubirFotoPacking(!modalSubirFotoPacking);
  const [modalFotoPacking, setModalFotoPacking] = useState(false);
  const toggleFotoPacking = () => setModalFotoPacking(!modalFotoPacking);

  const [modalSubirFotoBL, setModalSubirFotoBL] = useState(false);
  const toggleSubirFotoBL = () => setModalSubirFotoBL(!modalSubirFotoBL);
  const [modalFotoBL, setModalFotoBL] = useState(false);
  const toggleFotoBL = () => setModalFotoBL(!modalFotoBL);

  const [modalSubirFotoValidacion, setModalSubirFotoValidacion] = useState(false);
  const toggleSubirFotoValidacion = () => setModalSubirFotoValidacion(!modalSubirFotoValidacion);
  const [modalFotoValidacion, setModalFotoValidacion] = useState(false);
  const toggleFotoValidacion = () => setModalFotoValidacion(!modalFotoValidacion);

  const [modalSubirFotoInvoice, setModalSubirFotoInvoice] = useState(false);
  const toggleSubirFotoInvoice = () => setModalSubirFotoInvoice(!modalSubirFotoInvoice);
  const [modalFotoInvoice, setModalFotoInvoice] = useState(false);
  const toggleFotoInvoice = () => setModalFotoInvoice(!modalFotoInvoice);

  const [modalSubirFotoFichaTecnica, setModalSubirFotoFichaTecnica] = useState(false);
  const toggleSubirFotoFichaTecnica = () => setModalSubirFotoFichaTecnica(!modalSubirFotoFichaTecnica);
  const [modalFotoFichaTecnica, setModalFotoFichaTecnica] = useState(false);
  const toggleFotoFichaTecnica = () => setModalFotoFichaTecnica(!modalFotoFichaTecnica);

  const [modalSubirFotoCargosLocales, setModalSubirFotoCargosLocales] = useState(false);
  const toggleSubirFotoCargosLocales = () => setModalSubirFotoCargosLocales(!modalSubirFotoCargosLocales);
  const [modalFotoCargosLocales, setModalFotoCargosLocales] = useState(false);
  const toggleFotoCargosLocales = () => setModalFotoCargosLocales(!modalFotoCargosLocales);

  const [modalSubirFotoDODA, setModalSubirFotoDODA] = useState(false);
  const toggleSubirFotoDODA = () => setModalSubirFotoDODA(!modalSubirFotoDODA);
  const [modalFotoDODA, setModalFotoDODA] = useState(false);
  const toggleFotoDODA = () => setModalFotoDODA(!modalFotoDODA);

  const [modalSubirFotoBoleta, setModalSubirFotoBoleta] = useState(false);
  const toggleSubirFotoBoleta = () => setModalSubirFotoBoleta(!modalSubirFotoBoleta);
  const [modalFotoBoleta, setModalFotoBoleta] = useState(false);
  const toggleFotoBoleta = () => setModalFotoBoleta(!modalFotoBoleta);

  const [modalSubirFotoPrealta, setModalSubirFotoPrealta] = useState(false);
  const toggleSubirFotoPrealta = () => setModalSubirFotoPrealta(!modalSubirFotoPrealta);
  const [modalFotoPrealta, setModalFotoPrealta] = useState(false);
  const toggleFotoPrealta = () => setModalFotoPrealta(!modalFotoPrealta);

  const [modalSubirFotoEIR, setModalSubirFotoEIR] = useState(false);
  const toggleSubirFotoEIR = () => setModalSubirFotoEIR(!modalSubirFotoEIR);
  const [modalFotoEIR, setModalFotoEIR] = useState(false);
  const toggleFotoEIR = () => setModalFotoEIR(!modalFotoEIR);

  const [modalSubirFotoGarantia, setModalSubirFotoGarantia] = useState(false);
  const toggleSubirFotoGarantia = () => setModalSubirFotoGarantia(!modalSubirFotoGarantia);
  const [modalFotoGarantia, setModalFotoGarantia] = useState(false);
  const toggleFotoGarantia = () => setModalFotoGarantia(!modalFotoGarantia);

  const [modalSubirFotoTransporte, setModalSubirFotoTransporte] = useState(false);
  const toggleSubirFotoTransporte = () => setModalSubirFotoTransporte(!modalSubirFotoTransporte);
  const [modalFotoTransporte, setModalFotoTransporte] = useState(false);
  const toggleFotoTransporte = () => setModalFotoTransporte(!modalFotoTransporte);

  const [atraco, setAtraco] = useState('');
  // const [toquePiso, setToquePiso] = useState('');
  const [cartaEncomienda, setCartaEncomienda] = useState('');
  const [otrosDocumentos, setOtrosDocumentos] = useState('');
  const [archivoPendientes, setArchivoPendientes] = useState('');
  const [blRevalidado, setBlRevalidado] = useState('');
  const [clasificado, setClasificado] = useState('');
  const [carta318, setCarta318] = useState('');
  const [proformaPedimento, setProformaPedimento] = useState('');

    const [fechaAtraco, setFechaAtraco] = useState('');
  // const [fechaoquePiso, setFechaToquePiso] = useState('');
  const [fechaCartaEncomienda, setFechaCartaEncomienda] = useState('');
  const [fechaOtrosDocumentos, setFechaOtrosDocumentos] = useState('');
  const [fechaArchivoPendientes, setFechaArchivoPendientes] = useState('');
  const [fechaBlRevalidado, setFechaBlRevalidado] = useState('');
  const [fechaClasificado, setFechaClasificado] = useState('');
  const [fechaCarta318, setFechaCarta318] = useState('');
  const [fechaProformaPedimento, setFechaProformaPedimento] = useState('');

  const [archivoAtraco, setArchivoAtraco] = useState('');
  const [archivoToquePiso, setArchivoToquePiso] = useState('');
  const [archivoCartaEncomienda, setArchivoCartaEncomienda] = useState('');
  const [archivoOtrosDocumentos, setArchivoOtrosDocumentos] = useState('');
  const [archivoArchivoPendientes, setArchivoArchivoPendientes] = useState('');
  const [archivoBLRevalidado, setArchivoBLRevalidado] = useState('');
  const [archivoClasificado, setArchivoClasificado] = useState('');
  const [archivoCarta318, setArchivoCarta318] = useState('');
  const [archivoProformaPedimento, setArchivoProformaPedimento] = useState('');

  const [datoArchivoAtraco, setDatoArchivoAtraco] = useState('');
  const [datoArchivoToquePiso, setDatoArchivoToquePiso] = useState('');
  const [datoArchivoCartaEncomienda, setDatoArchivoCartaEncomienda] = useState('');
  const [datoArchivoOtrosDocumentos, setDatoArchivoOtrosDocumentos] = useState('');
  const [datoArchivoArchivoPendientes, setDatoArchivoArchivoPendientes] = useState('');
  const [datoArchivoBLRevalidado, setDatoArchivoBLRevalidado] = useState('');
  const [datoArchivoClasificado, setDatoArchivoClasificado] = useState('');
  const [datoArchivoCarta318, setDatoArchivoCarta318] = useState('');
  const [datoArchivoProformaPedimento, setDatoArchivoProformaPedimento] = useState('');

  const [packing, setPacking] = useState('');
  const [blArchivo, setBlArchivo] = useState('');
  const [validacion, setValidacion] = useState('');
  const [invoice, setInvoice] = useState('');
  const [fichaTecnicaArchivo, setFichaTecnicaArchivo] = useState('');
  const [cargosLocales, setCargosLocales] = useState('');
  const [DODA, setDODA] = useState('');
  const [boleta, setBoleta] = useState('');
  const [prealta, setPrealta] = useState('');
  const [EIR, setEIR] = useState('');
  const [garantia, setGarantia] = useState('');
  const [transporte, setTransporte] = useState('');


  const [modalFotos, setModalFotos] = useState(false);
  const toggleFotos = () => setModalFotos(!modalFotos);


  const [photo, setPhoto] = useState([]);
  const [idContenedor, setIdContenedor] = useState();
  const [file, setFile] = useState([]);

  const [validaBoton, setValidaBoton] = useState(true);
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: '',
      cantidad: 0,
      precio: 0,
      total: 0,
    },
  ]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState('');

  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);

  const [modalETA, setModalETA] = useState(false);
  const toggleETA = () => setModalETA(!modalETA);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [modalStatus, setModalStatus] = useState(false);
  const toggleStatus = () => setModalStatus(!modalStatus);
  const [id, setid] = useState('');
  const [bl, setbl] = useState('');
  const [pl, setpl] = useState('');
  const [pedimento, setPedimento] = useState('');
  const [factura, setfactura] = useState('');
  const [modalidad, setModalidad] = useState('');
  const [asegurado, setAsegurado] = useState('');
  const [documentos, setdocumentos] = useState('');
  const [telex, settelex] = useState('');
  const [toquePiso, settoquePiso] = useState('');
  const [libreAlmacenajes, setLibreAlmacenajes] = useState('');
  const [revalidacion, setrevalidacion] = useState('');
  const [fichaTecnica, setfichaTecnica] = useState('');
  const [pagoPedimento, setpagoPedimento] = useState('');
  const [modulacion, setmodulacion] = useState('');
  const [retornoVacio, setretornoVacio] = useState('');
  const [salidaPuerto, setsalidaPuerto] = useState('');
  const [salidaRuta, setsalidaRuta] = useState('');
  const [entregaCliente, setentregaCliente] = useState('');
  const [maniobras, setmaniobras] = useState('');
  const [status, setstatus] = useState('');
  const [fechaEntradaPuerto, setfechaEntradaPuerto] = useState('');
  const [fechaDocumentos, setfechaDocumentos] = useState('');
  const [fechaTelex, setfechaTelex] = useState('');
  const [fechaToquePiso, setfechaToquePiso] = useState('');
  const [fechaLibreAlmacenajes, setfechaLibreAlmacenajes] = useState('');
  const [fechaRevalidacion, setfechaRevalidacion] = useState('');
  const [fechaFichaTecnica, setfechaFichaTecnica] = useState('');
  const [fechaPagoPedimento, setfechaPagoPedimento] = useState('');
  const [fechaModulacion, setfechaModulacion] = useState('');
  const [fechaRetornoVacio, setfechaRetornoVacio] = useState('');
  const [fechaSalidaPuerto, setfechaSalidaPuerto] = useState('');
  const [fechaSalidaRuta, setfechaSalidaRuta] = useState('');
  const [fechaEntregaCliente, setfechaEntregaCliente] = useState('');
  const [fechaManiobras, setfechaManiobras] = useState('');
  const [fechaFactura, setfechaFactura] = useState('');
  const [fechaBl, setfechaBl] = useState('');
  const [fechaPl, setfechaPl] = useState('');

  const [modalGastos, setModalGastos] = useState(false);
  const toggleGastos = () => setModalGastos(!modalGastos);
  const [fechaGasto, setFechaGasto] = useState(endDate);
  const [totalUSD, setTotalUSD] = useState(0);
  const [tipoCambio, setTipoCambio] = useState(1);
  const [total, setTotal] = useState(0);
  const [descripcion, setDescripcion] = useState('NA');
  const [conceptosGastos, setConceptosGastos] = useState([]);
  const [selectedConcepto, setSelectedConcepto] = useState('');
  const [selectedProveedor, setSelectedProveedor] = useState('');
  const [selectedContenedor, setSelectedContenedor] = useState(null);
  const [selectedClienteGasto, setSelectedClienteGasto] = useState('');
  const [moneda, setMoneda] = useState('MXN');

  const [modalCargos, setModalCargos] = useState(false);
  const toggleCargos = () => setModalCargos(!modalCargos);

const [modalOpenPedimentos, setModalOpenPedimentos] = useState(false);
const openPedimentosModal = async (contenedor) => {
  try {
    const headers = {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`, // usa el mismo formato que tu app
    };

    const res = await axios.get(`${URL_CONTENEDORES}/${contenedor._id}`, {
      headers,
    });

    // aquí res.data debe ser el contenedor completo
    setSelectedContenedor(res.data);
    setModalOpenPedimentos(true);
  } catch (err) {
    console.log(err);
    Swal.fire("Error", "No pude cargar los pedimentos del contenedor", "error");
  }
};


const closePedimentosModal = () => {
  setModalOpenPedimentos(false);
  setSelectedContenedor(null);
};

const [nuevoPedimento, setNuevoPedimento] = useState("");
const [obsPedimento, setObsPedimento] = useState("");
const [loadingPedimento, setLoadingPedimento] = useState(false);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState('');
  const [sorting, setSorting] = useState({ field: '', order: '' });

  const ITEMS_PER_PAGE = 50;

  const IVA = 0.16;

const TARIFA_DEMORAS = 3400;
const TARIFA_ALMACENAJES = 2400;

  useMemo(() => {
     // Helpers (ponlos arriba, fuera del .then)
const MS_PER_DAY = 24 * 60 * 60 * 1000;
const parseYMD = (s) => {
  if (!s) return null;
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, (m || 1) - 1, d || 1); // fecha local 00:00
};
const startOfToday = () => {
  const t = new Date();
  t.setHours(0,0,0,0);
  return t;
};
const diffDays = (start, end) => {
  if (!start || !end) return 0;
  const ms = end - start;
  return Math.max(0, Math.floor(ms / MS_PER_DAY));
};
    axios
      .get(
        `${URL_CONTENEDORES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then((response) => {
        let allContenedores = response.data;
        // Array para pagination
        let arrayTabla = allContenedores
          .sort((a, b) => (a.etaReal > b.etaReal ? 1 : -1))
          .map((a) => {
            // Fechas base
  // Fechas base
const eta = parseYMD(a.etaReal); // inicio
const hoy = startOfToday();

// --- 1) DEMORAS cobrables ---
// etaReal -> fechaModulacion (o hoy), si ya pasó etaReal
const finDemoras = parseYMD(a.fechaModulacion) || hoy;
const libresDemoras = Number(a.diasLibresDemoras) || 0;

const brutosDemoras = eta && hoy >= eta ? diffDays(eta, finDemoras) : 0;
const diasDemorasCobrables = Math.max(0, brutosDemoras - libresDemoras);

// --- 2) ALMACENAJES cobrables ---
// etaReal -> fechaRetornoVacio (o hoy), si ya pasó etaReal
const finAlmacen = parseYMD(a.fechaRetornoVacio) || hoy;
const libresAlmacenajes = Number(a.diasLibresAlmacenajes) || 0;

const brutosAlmacenajes = eta && hoy >= eta ? diffDays(eta, finAlmacen) : 0;
const diasAlmacenajesCobrables = Math.max(0, brutosAlmacenajes - libresAlmacenajes);

// ==========================
// TOTALES DEMORAS
// ==========================
const totalDemoras =
  diasDemorasCobrables * TARIFA_DEMORAS * (1 + IVA);

// ==========================
// TOTALES ALMACENAJES
// ==========================
const totalAlmacenajes =
  diasAlmacenajesCobrables * TARIFA_ALMACENAJES * (1 + IVA);

// ==========================
// TOTAL GENERAL
// ==========================
const totalDemorasYAlmacenajes =
  totalDemoras + totalAlmacenajes;

const pedimentoVigente =
  (a.pedimentos || []).find((p) => p?.is_active === "Si")?.numero ||
  (a.pedimento && a.pedimento !== "NA" ? a.pedimento : "");


            return {
              _id: a._id,
              numero: a.idContenedor,
              activo: a.is_active,
              fecha: a.fecha,
              fechaCita: a.fechaCita,
              observaciones: a.observaciones,
              observacionesInternas: a.observacionesInternas,
              totalGeneral: a.totalGeneral,
              navieras: a.navieras[0].name,
              idNavieras: a.navieras[0]._id,
              clientes: a.clientes[0].nombre_comercial,
              idClientes: a.clientes[0]._id,
              agentes: a.agentes[0].name,
              idAgentes: a.agentes[0]._id,
              agencias: a.agencias[0].name,
              idAgencias: a.agencias[0]._id,
              comisionistas: a.comisionistas[0].name,
              idComisionistas: a.comisionistas[0]._id,
              transportistas: a.transportistas[0].name,
              idTransportistas: a.transportistas[0]._id,
              terminales: a.terminales[0].name,
              idTerminales: a.terminales[0]._id,
              programas: a.programas[0].name,
              idProgramas: a.programas[0]._id,
              patentes: a.patentes[0].name,
              idPatentes: a.patentes[0]._id,
              forwarders: a.forwarders[0].name,
              idForwarders: a.forwarders[0]._id,
              totalCantidad: a.totalCantidad,
              numeroInterno:
                a.clientes[0].nombre_comercial + '-' + a.consecutivoCliente,
              contenedor: a.contenedor,
              // etaEstimada: a.etaEstimada,
              etaReal: a.etaReal,
              bl: a.bl,
              pl: a.pl,
              invoice: a.invoice,
              fichaTecnicaArchivo: a.fichaTecnicaArchivo,
              cargosLocales: a.cargosLocales,
              DODA: a.DODA,
              boleta: a.boleta,
              prealta: a.prealta,
              EIR: a.EIR,
              validacion: a.validacion,
              garantia: a.garantia,
              packing: a.packing,
              transporte: a.transporte,
              totalGastos: a.totalGastos,
              puerto: a.puerto,
              puertoOrigen: a.puertoOrigen,
              numeroBl: a.numeroBl,
              direccionEntrega: a.direccionEntrega,
              totalCargos: a.totalCargos,
              modalidad: a.modalidad,

              asegurado: a.asegurado,

              factura: a.factura,
              documentos: a.documentos,
              telex: a.telex,
              toquePiso: a.toquePiso,
              libreAlmacenajes: a.libreAlmacenajes,
              revalidacion: a.revalidacion,
              fichaTecnica: a.fichaTecnica,
              pagoPedimento: a.pagoPedimento,
              modulacion: a.modulacion,
              retornoVacio: a.retornoVacio,
              salidaPuerto: a.salidaPuerto,
              salidaRuta: a.salidaRuta,
              entregaCliente: a.entregaCliente,
              maniobras: a.maniobras,
              status: a.status,
              fechaEntradaPuerto: a.fechaEntradaPuerto,
              fechaDocumentos: a.fechaDocumentos,
              fechaTelex: a.fechaTelex,
              fechaToquePiso: a.fechaToquePiso,
              fechaLibreAlmacenajes: a.fechaLibreAlmacenajes,
              fechaRevalidacion: a.fechaRevalidacion,
              fechaFichaTecnica: a.fechaFichaTecnica,
              fechaPagoPedimento: a.fechaPagoPedimento,
              fechaModulacion: a.fechaModulacion,
              fechaRetornoVacio: a.fechaRetornoVacio,
              fechaSalidaPuerto: a.fechaSalidaPuerto,
              fechaSalidaRuta: a.fechaSalidaRuta,
              fechaEntregaCliente: a.fechaEntregaCliente,
              fechaManiobras: a.fechaManiobras,
              fechaFactura: a.fechaFactura,
              fechaBl: a.fechaBl,
              fechaPl: a.fechaPl,

              rastreo:a.rastreo,
              mapa:a.mapa,
              fromCountry: a.fromCountry,
              polOrigen: a.polOrigen,
              loadingDate: a.loadingDate,
              departureDate: a.departureDate,
              toCountry: a.toCountry,
              podDestino: a.podDestino,
              arrivalDate: a.arrivalDate,
              dischargeDate: a.dischargeDate,
              vessel: a.vessel,
              vesselIMO: a.vesselIMO,
              vesselLatitude: a.vesselLatitude,
              vesselLongitude: a.vesselLongitude,
              vesselVoyage: a.vesselVoyage,
              polLatitude: a.polLatitude,
              polLongitude: a.polLongitude,
              podLatitude: a.podLatitude,
              podLongitude: a.podLongitude,
              vesselLatitude: a.vesselLatitude,
              vesselLongitude: a.vesselLongitude,
              pesoTotal: a.pesoTotal,

              diasLibresDemoras: a.diasLibresDemoras,
            diasLibresAlmacenajes: a.diasLibresAlmacenajes,
            tamanoContenedor: a.tamanoContenedor,
            pesoContenedor: a.pesoContenedor,
            buque: a.buque,
            regimen: a.regimen,
            claveRegimen: a.claveRegimen,
            recinto: a.recinto,
            selloContenedor: a.selloContenedor,
            referenciaPatente: a.referenciaPatente,
            ejecutivo: a.ejecutivo,
            pedimento: pedimentoVigente,
            pedimentos: a.pedimentos || [], // 👈 IMPORTANTÍSIMO para el modal

            atraco: a.atraco,
            fechaAtraco: a.fechaAtraco,
            archivoAtraco: a.archivoAtraco,
            cartaEncomienda: a.cartaEncomienda,
            fechaCartaEncomienda: a.fechaCartaEncomienda,
            archivoCartaEncomienda: a.archivoCartaEncomienda,
            otrosDocumentos: a.otrosDocumentos,
            fechaOtrosDocumentos: a.fechaOtrosDocumentos,
            archivoOtrosDocumentos: a.archivoOtrosDocumentos,
            archivoPendientes: a.archivoPendientes,
            fechaArchivoPendientes: a.fechaArchivoPendientes,
            archivoArchivoPendientes: a.archivoArchivoPendientes,
            BLRevalidado: a.BLRevalidado,
            fechaBLRevalidado: a.fechaBLRevalidado,
            archivoBLRevalidado: a.archivoBLRevalidado,
            clasificado: a.clasificado,
            fechaClasificado: a.fechaClasificado,
            archivoClasificado: a.archivoClasificado,
            carta318: a.carta318,
            fechaCarta318: a.fechaCarta318,
            archivoCarta318: a.archivoCarta318,
            proformaPedimento: a.proformaPedimento,
            fechaProformaPedimento: a.fechaProformaPedimento,
            archivoProformaPedimento: a.archivoProformaPedimento,


    // 👇 NUEVOS CAMPOS
    diasDemorasCobrables,
    diasAlmacenajesCobrables,

    totalDemoras,
  totalAlmacenajes,
  totalDemorasYAlmacenajes,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setComments(dataFinal);
        //
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_CLIENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_TERMINALES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allTerminales = response.data;
        setTerminales(allTerminales);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_PROVEEDORES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allProveedores = res.data;
        setProveedores(allProveedores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${URL_PROGRAMAS}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allProgramas = res.data;
        setProgramas(allProgramas);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_PATENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allPatentes = res.data;
        setPatentes(allPatentes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_CONCEPTOS_GASTOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((res) => {
        const allConceptosGastos = res.data;
        setConceptosGastos(allConceptosGastos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedStatus == 0 || selectedStatus == a.status) &&
        (selectedRevalidacion == 0 || selectedRevalidacion == a.revalidacion) &&
        (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
        (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
        (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
        (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
        (selectedTransportista == 0 || selectedTransportista == a.idTransportistas) &&
        (selectedAgencia == 0 || selectedAgencia == a.idAgencias) &&
        (selectedComisionista == 0 || selectedComisionista == a.idComisionistas) &&
        (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return [
          a.etaReal,
          a.numeroInterno,
          a.contenedor,
          a.navieras,
          a.clientes,
          a.forwarders,
          a.puerto,
          a.modalidad,
          a.fechaModulacion,
          a.fechaEntregaCliente,
          a.status,
          a.observaciones,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF('landscape');
    var img = new Image();
    img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
    doc.addImage(img, 'png', 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
    doc.addImage(img2, 'png', 120, 15, 65, 28);
    doc.text(`Listado Contenedores`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          'ETA',
          'No. Interno',
          'Contenedor',
          'Naviera',
          'Cliente',
          'Forwarder',
          'Puerto',
          'Modalidad',
          'Modulacion',
          'Entrega Cliente',
          'Status',
          'Observaciones',
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Contenedores.pdf`);
  }

    function PDFTablaCliente() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedStatus == 0 || selectedStatus == a.status) &&
        (selectedRevalidacion == 0 || selectedRevalidacion == a.revalidacion) &&
        (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
        (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
        (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
        (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
        (selectedTransportista == 0 || selectedTransportista == a.idTransportistas) &&
        (selectedAgencia == 0 || selectedAgencia == a.idAgencias) &&
        (selectedComisionista == 0 || selectedComisionista == a.idComisionistas) &&
        (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return [
          a.etaReal,
          a.contenedor,
          a.status,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF();
    var img = new Image();
    img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
    doc.addImage(img, 'png', 150, 5, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
    doc.addImage(img2, 'png', 150, 25, 35, 15);
    doc.text(`Listado Contenedores`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          'ETA',
          'Contenedor',
          'Status',
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    doc.save(`Contenedores.pdf`);
  }

function PDFTablaPiso() {
  const data = comments
    .filter((a) => 
      a.status === "En Piso" && // ✅ Solo "En Piso"
      (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
      (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
      (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
      (selectedCliente == 0 || selectedCliente == a.idClientes) &&
      (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
      (selectedStatus == 0 || selectedStatus == a.status) &&
      (selectedRevalidacion == 0 || selectedRevalidacion == a.revalidacion) &&
      (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
      (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
      (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
      (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
      (selectedTransportista == 0 || selectedTransportista == a.idTransportistas) &&
      (selectedAgencia == 0 || selectedAgencia == a.idAgencias) &&
      (selectedComisionista == 0 || selectedComisionista == a.idComisionistas) &&
      (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
      (selectedActivo == 0 || selectedActivo == a.activo)
    )
    .sort((a, b) => {
      // ✅ Ordenar primero por cliente, luego por fecha
      const clienteA = (a.clientes || "").toLowerCase();
      const clienteB = (b.clientes || "").toLowerCase();
      if (clienteA < clienteB) return -1;
      if (clienteA > clienteB) return 1;
      // Si los clientes son iguales, ordenar por fecha
      const fechaA = new Date(a.fechaToquePiso);
      const fechaB = new Date(b.fechaToquePiso);
      return fechaA - fechaB;
    })
    .map((a) => [
      a.clientes,
      a.contenedor,
      a.puerto,
      a.fechaToquePiso,
      a.recinto
    ]);

  const doc = new jsPDF();
  const img = new Image();
  img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
  doc.addImage(img, 'png', 150, 5, 33, 10);
  const img2 = new Image();
  img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
  doc.addImage(img2, 'png', 150, 25, 35, 15);
  doc.text(`Listado Contenedores En Piso`, 20, 30);
  doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
  doc.autoTable({
    head: [['Cliente', 'Contenedor', 'Puerto Destino', 'Toque Piso', 'Recinto']],
    body: data,
    startY: 45,
  });
  doc.save(`Contenedores_EnPiso.pdf`);
}

function PDFTablaEIR() {
  const data = comments
    .filter((a) => 
      a.retornoVacio === "No" &&
      (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
      (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
      (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
      (selectedCliente == 0 || selectedCliente == a.idClientes) &&
      (selectedStatus == 0 || selectedStatus == a.status) &&
      (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
      (selectedStatus == 0 || selectedStatus == a.status) &&
      (selectedRevalidacion == 0 || selectedRevalidacion == a.revalidacion) &&
      (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
      (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
      (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
      (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
      (selectedTransportista == 0 || selectedTransportista == a.idTransportistas) &&
      (selectedAgencia == 0 || selectedAgencia == a.idAgencias) &&
      (selectedComisionista == 0 || selectedComisionista == a.idComisionistas) &&
      (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
      (selectedActivo == 0 || selectedActivo == a.activo)
    )
    .sort((a, b) => {
      // ✅ Ordenar primero por cliente, luego por fecha
      const clienteA = (a.clientes || "").toLowerCase();
      const clienteB = (b.clientes || "").toLowerCase();
      if (clienteA < clienteB) return -1;
      if (clienteA > clienteB) return 1;
      // Si los clientes son iguales, ordenar por fecha
      const fechaA = new Date(a.fechaToquePiso);
      const fechaB = new Date(b.fechaToquePiso);
      return fechaA - fechaB;
    })
    .map((a) => [
      a.clientes,
      a.contenedor,
      a.puerto,
      a.recinto
    ]);

  const doc = new jsPDF();
  const img = new Image();
  img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
  doc.addImage(img, 'png', 150, 5, 33, 10);
  const img2 = new Image();
  img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
  doc.addImage(img2, 'png', 150, 25, 35, 15);
  doc.text(`Listado Contenedores Sin Retorno`, 20, 30);
  doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
  doc.autoTable({
    head: [['Cliente', 'Contenedor', 'Puerto Destino', 'Recinto']],
    body: data,
    startY: 45,
  });
  doc.save(`Contenedores_SinRetorno.pdf`);
}

function PDFTablaPorArribar() {
  // === Helpers fechas ===
  const toDateYMD = (s) => {
    if (!s) return null;
    const [y, m, d] = String(s).split("-").map(Number);
    return new Date(y, (m || 1) - 1, d || 1, 0, 0, 0, 0);
  };
  const startOfMondayWeek = (d) => {
    const dt = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const day = dt.getDay(); // 0=Dom
    const diff = (day === 0 ? -6 : 1 - day);
    dt.setDate(dt.getDate() + diff);
    dt.setHours(0,0,0,0);
    return dt;
  };
  const endOfSundayWeek = (d) => {
    const monday = startOfMondayWeek(d);
    const sunday = new Date(monday);
    sunday.setDate(sunday.getDate() + 6);
    sunday.setHours(23,59,59,999);
    return sunday;
  };
  const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
  const addWeeks = (d, n) => addDays(d, n * 7);
  const meses = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
  const fmtWeekLabel = (s, e) => `Del ${s.getDate()} ${meses[s.getMonth()]} al ${e.getDate()} ${meses[e.getMonth()]}`;
  const fmtCurrency = (n) =>
    Number(n || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 0 });

  // Base con etaReal parseada
  const all = (comments || [])
    .map(x => ({ ...x, _eta: toDateYMD(x?.etaReal) }))
    .filter(x => x._eta instanceof Date && !isNaN(+x._eta));

  if (all.length === 0) {
    Swal.fire({ icon: "info", title: "Sin datos", text: "No hay registros con etaReal para reportar." });
    return;
  }

  // Próximas 5 semanas desde hoy
  const hoy = new Date();
  const inicio = startOfMondayWeek(hoy);
  const fin = endOfSundayWeek(addWeeks(hoy, 4)); // 5 semanas

  const weeks = [];
  for (let s = startOfMondayWeek(inicio); s <= fin; s = addWeeks(s, 1)) {
    const e = endOfSundayWeek(s);
    weeks.push({ start: s, end: e, label: fmtWeekLabel(s, e) });
  }

  // Filtros (los tuyos) + rango semanas por etaReal
  const filtered = all.filter((a) =>
    a._eta >= weeks[0].start &&
    a._eta <= weeks[weeks.length - 1].end &&
    (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
    (selectedCliente == 0 || selectedCliente == a.idClientes) &&
    (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
    (selectedStatus == 0 || selectedStatus == a.status) &&
    (selectedRevalidacion == 0 || selectedRevalidacion == a.revalidacion) &&
    (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
    (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
    (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
    (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
    (selectedTransportista == 0 || selectedTransportista == a.idTransportistas) &&
    (selectedAgencia == 0 || selectedAgencia == a.idAgencias) &&
    (selectedComisionista == 0 || selectedComisionista == a.idComisionistas) &&
    (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
    (selectedActivo == 0 || selectedActivo == a.activo)
  );

  // Agrupar por (STATUS, CLIENTE) y sumar por semana
  const rowsMap = new Map(); // key = `${STATUS}||${CLIENTE}`
  filtered.forEach((a) => {
    const status = (a?.status || "SIN STATUS").toUpperCase();
    const cliente = a?.clientes || "—";
    const key = `${status}||${cliente}`;
    if (!rowsMap.has(key)) {
      rowsMap.set(key, { cliente, status, weekly: Array(weeks.length).fill(0) });
    }
    const row = rowsMap.get(key);
    const eta = a._eta;
    const idx = weeks.findIndex(w => eta >= w.start && eta <= w.end);
    if (idx >= 0) row.weekly[idx] += Number(a?.totalCargos || 0);
  });

  // Construir filas ordenadas por STATUS y luego CLIENTE
  const rows = Array.from(rowsMap.values())
    .sort((x, y) => x.status.localeCompare(y.status) || x.cliente.localeCompare(y.cliente))
    .map((r) => {
      const total = r.weekly.reduce((acc, n) => acc + n, 0);
      return [
        r.cliente,
        r.status,
        ...r.weekly.map(fmtCurrency),
        fmtCurrency(total)
      ];
    });

  const head = [[ "CLIENTE", "STATUS", ...weeks.map(w => w.label), "Total general" ]];

  // PDF
  const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "letter" });
  try {
  const img = new Image();
  img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
  const logoWidth = 120;
  const logoHeight = 35;
  const marginRight = 30; // margen al borde derecho
  const pageWidth = doc.internal.pageSize.getWidth();
  const xPos = pageWidth - logoWidth - marginRight; // posición a la derecha
  doc.addImage(img, "PNG", xPos, 24, logoWidth, logoHeight);
} catch {}
  // try {
  //   const img2 = new Image();
  //   img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  //   doc.addImage(img2, "PNG", 460, 70, 120, 45);
  // } catch {}

  doc.setFontSize(14);
  doc.text("POR ARRIBAR - Próximas 5 semanas", 40, 50);
  doc.setFontSize(10);
  doc.text(`${fmtWeekLabel(weeks[0].start, weeks[0].end)} — ${fmtWeekLabel(weeks[weeks.length - 1].start, weeks[weeks.length - 1].end)}`, 40, 66);

  doc.autoTable({
    head,
    body: rows,
    startY: 90,
    styles: { fontSize: 9, cellPadding: 6, halign: "right" },
    headStyles: { halign: "center" },
    columnStyles: { 0: { halign: "left" }, 1: { halign: "center" } },
    didParseCell: (data) => {
      if (data.section === 'body' && data.column.index === 0) {
        data.cell.styles.halign = 'left';
        data.cell.styles.fontStyle = 'bold';
      }
    }
  });

  doc.save("Por_Arribar_Proximas_5_Semanas.pdf");
}




  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedStatus == 0 || selectedStatus == a.status) &&
        (selectedRevalidacion == 0 || selectedRevalidacion == a.revalidacion) &&
        (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
        (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
        (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
        (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
        (selectedTransportista == 0 || selectedTransportista == a.idTransportistas) &&
        (selectedAgencia == 0 || selectedAgencia == a.idAgencias) &&
        (selectedComisionista == 0 || selectedComisionista == a.idComisionistas) &&
        (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return {
          ID: a._id,
          Numero: a.numero,
          ETA: a.etaReal,
          NumeroInterno: a.numeroInterno,
          Contenedor: a.contenedor,
          FechaCita: a.fechaCita,
          BL: a.numeroBl,
          Naviera: a.navieras,
          Cliente: a.clientes,
          AgenteAduanal: a.agentes,
          Forwarder: a.forwarders,
          Puerto: a.puerto,
          Modalidad: a.modalidad,
          Asegurado: a.asegurado,
          Modulacion: a.fechaModulacion,
          Status: a.status,
          // Maniobras: a.fechaManiobras,
          Patente: a.patente,
          EntregaCliente: a.fechaEntregaCliente,
          Observaciones: a.observaciones,
          ObservacionesInternas: a.observacionesInternas,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = 'ListadoContenedores';

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: 'ListadoContenedores',
        sheetFilter: [
          'ID',
          'Numero',
          'ETA',
          'NumeroInterno',
          'Contenedor',
          'FechaCita',
          'BL',
          'Naviera',
          'Cliente',
          'AgenteAduanal',
          'Forwarder',
          'Puerto',
          'Modalidad',
          'Asegurado',
          'Modulacion',
          'Status',
          // 'Maniobras',
          'Patente',
          'EntregaCliente',
          'Observaciones',
          'ObservacionesInternas',
        ],
        sheetHeader: [
          'ID',
          'Numero',
          'ETA',
          'NumeroInterno',
          'Contenedor',
          'FechaCita',
          'BL',
          'Naviera',
          'Cliente',
          'AgenteAduanal',
          'Forwarder',
          'Puerto',
          'Modalidad',
          'Asegurado',
          'Modulacion',
          'Status',
          // 'Maniobras',
          'Patente',
          'EntregaCliente',
          'Observaciones',
          'ObservacionesInternas',
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = comments.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedNaviera == 0 || selectedNaviera == a.idNavieras) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes) &&
        (selectedForwarder == 0 || selectedForwarder == a.idForwarders) &&
        (selectedStatus == 0 || selectedStatus == a.status) &&
        (selectedRevalidacion == 0 || selectedRevalidacion == a.revalidacion) &&
        (selectedPuerto == 0 || selectedPuerto == a.puerto) &&
        (selectedModalidad == 0 || selectedModalidad == a.selectedModalidad) &&
        (selectedAsegurado == 0 || selectedAsegurado == a.selectedAsegurado) &&
        (selectedAgente == 0 || selectedAgente == a.idAgentes) &&
        (selectedTransportista == 0 || selectedTransportista == a.idTransportistas) &&
        (selectedAgencia == 0 || selectedAgencia == a.idAgencias) &&
        (selectedComisionista == 0 || selectedComisionista == a.idComisionistas) &&
        (selectedPendiente == 0 || selectedPendiente == a.entregaCliente) &&
        (selectedActivo == 0 || selectedActivo == a.activo)
      ) {
        return [
          a.numero,
          a.fecha,
          a.etaReal,
          a.numeroInterno,
          a.contenedor,
          a.navieras,
          a.clientes,
          a.agentes,
          a.forwarders,
          a.puerto,
          a.terminal,
          a.modalidad,
          a.fechaSalidaPuerto,
          a.fechaSalidaRuta,
          a.status,
          a.observaciones,
          a.programa,
          a.totalCantidad,
          new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            maximumFractionDigits: 2,
          }).format(a.totalGeneral),
          a.direccionEntrega,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF('landscape');
    var img = new Image();
    img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
    doc.addImage(img, 'png', 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
    doc.addImage(img2, 'png', 120, 15, 65, 28);
    doc.text(`Listado Contenedores`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          'Numero',
          'Fecha',
          'ETA',
          'No. Interno',
          'Contenedor',
          'Naviera',
          'Cliente',
          'Agente Aduanal',
          'Forwarder',
          'Puerto',
          'Terminal',
          'Modalidad',
          'Salida Puerto',
          'Salida Ruta',
          'Status',
          'Observaciones',
          'Programa',
          'Cantidad',
          'Total',
          'Direccion Entrega',
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output('arraybuffer');
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: 'Listado Contenedores',
          email: mailTo,
          fileName: 'ListadoContenedores.pdf',
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Contenedores.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire('Good job!', 'Enviado con exito', 'success');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  function jalaInfo(
    fecha,
    idNavieras,
    idClientes,
    idAgentes,
    idAgencias,
    idComisionistas,
    idTransportistas,
    idForwarders,
    totalCantidad,
    totalGeneral,
    observaciones,
    observacionesInternas,
    numeroContenedor,
    numeroInterno,
    contenedor,
    // etaEstimada,
    etaReal,
    puerto,
    puertoOrigen,
    numeroBl,
    fechaCita,
    idTerminales,
    pedimento,
    modalidad,
    asegurado,
    direccionEntrega,
    idProgramas,
    idPatentes,
    rastreo,
    pesoTotal,
    recinto,
    totalCargos,
    totalGastos,
    diasLibresDemoras,
    diasLibresAlmacenajes,
    tamanoContenedor,
    pesoContenedor,
    buque,
    regimen,
    claveRegimen,
    selloContenedor,
    referenciaPatente,
    ejecutivo,
    idEdit
  ) {
    setFecha(fecha);
    setSelectedNavieraEdit(idNavieras);
    setSelectedClienteEdit(idClientes);
    setSelectedAgenteEdit(idAgentes);
    setSelectedAgenciaEdit(idAgencias);
    setSelectedComisionistaEdit(idComisionistas);
    setSelectedTransportistaEdit(idTransportistas);
    setSelectedForwarderEdit(idForwarders);
    setTotalCantidad(totalCantidad);
    setTotalGeneral(totalGeneral);
    setObservaciones(observaciones);
    setObservacionesInternas(observacionesInternas);
    setNumeroContenedor(numeroContenedor);
    setnumeroInterno(numeroInterno);
    setContenedor(contenedor);
    // setFechaETAEstimada(etaEstimada);
    setFechaETAReal(etaReal);
    setPuerto(puerto);
    setPuertoOrigen(puertoOrigen);
    setNumeroBl(numeroBl);
    setFechaCita(fechaCita);
    setSelectedTerminal(idTerminales);
    setPedimento(pedimento);
    setModalidad(modalidad);
    setAsegurado(asegurado);
    setDireccionEntrega(direccionEntrega);
    setSelectedPrograma(idProgramas);
    setSelectedPatente(idPatentes);
    setRastreo(rastreo);
    setPesoTotal(pesoTotal);
    setRecinto(recinto);
    setTotalCargos(totalCargos);
    setTotalGastos(totalGastos);
    setIdEdit(idEdit);
    setDiasLibresDemoras(diasLibresDemoras);
    setDiasLibresAlmacenajes(diasLibresAlmacenajes);
    setTamanoContenedor(tamanoContenedor);
    setPesoContenedor(pesoContenedor);
    setBuque(buque);
    setRegimen(regimen);
    setClaveRegimen(claveRegimen);
    setSelloContenedor(selloContenedor);
    setReferenciaPatente(referenciaPatente);
    setEjecutivo(ejecutivo);
    toggleEdit();
  }

  async function PDFOC(
    fecha,
    idNavieras,
    navieras,
    clientes,
    agentes,
    totalCantidad,
    totalGeneral,
    observaciones,
    numero,
    idPDFOC
  ) {
    await axios
      .get(`${URL_ARTICULOS_CONTENEDOR}/contenedor/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allArticulosContenedor = response.data;
        let arrayTabla = allArticulosContenedor
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0].name,
              descripcion: a.descripcion,
              cantidad: a.cantidad,
              precio: a.precio,
              total: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let cant = inputFields.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidad(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);

        const data = dataFinal.map((a) => {
          return [
            a.articulos,
            a.descripcion,
            new Intl.NumberFormat('en-US').format(a.cantidad),
            new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 2,
            }).format(a.precio),
            new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 2,
            }).format(a.total),
          ];
        });
        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF('landscape');
        var img = new Image();
        img.src = process.env.PUBLIC_URL + 'Logo-Lynqro-PDF.png';
        doc.addImage(img, 'png', 230, 30, 45, 15);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + 'logoInstitucion.png';
        doc.addImage(img2, 'png', 120, 15, 45, 15);
        doc.text(`Contenedor # ${numero}`, 20, 20);
        doc.setFontSize(12);
        doc.text(`Fecha ${fecha}`, 20, 25);
        doc.text(`Naviera ${navieras}`, 20, 30);
        doc.text(
          `Piezas ${new Intl.NumberFormat('en-US').format(totalCantidad)}`,
          20,
          40
        );
        doc.autoTable({
          head: [['Articulo', 'Descripcion', 'Cantidad', 'Precio', 'Total']],
          body: dataPDFLimpia,
          startY: 45,
          foot: [
            [
              '',
              '',
              '',
              'Total',
              new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
              }).format(totalGeneral),
            ],
          ],
          showFoot: 'lastPage',
        });
        doc.save(`Contenedor-${numero}.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function editContenedores(event) {
    event.preventDefault();
    const URL_CONTENEDORES_EDIT = `${process.env.REACT_APP_URL_CONTENEDORES}/${idEdit}`;

    axios
      .patch(
        URL_CONTENEDORES_EDIT,
        {
          fecha,
          fechaCita,
          navieras: selectedNavieraEdit,
          clientes: selectedClienteEdit,
          agentes: selectedAgenteEdit,
          agencias: selectedAgenciaEdit,
          comisionistas: selectedComisionistaEdit,
          transportistas: selectedTransportistaEdit,
          forwarders: selectedForwarderEdit,
          observaciones,
          observacionesInternas,
          numeroInterno,
          contenedor,
          // etaEstimada: fechaETAEstimada,
          etaReal: fechaETAReal,
          puerto,
          terminales: selectedTerminal,
          pedimento,
          modalidad,
          asegurado,
          direccionEntrega,
          programas: selectedPrograma,
          patentes: selectedPatente,
          numeroBl,
          puertoOrigen,
          pesoTotal,
          recinto,

          diasLibresDemoras,
          diasLibresAlmacenajes,
          tamanoContenedor,
          pesoContenedor,
          buque,
          regimen,
          claveRegimen,
          recinto,
          selloContenedor,
          referenciaPatente,
          ejecutivo,
          pedimento,          
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: 'Editar Contenedor',
            detalle: `${numeroContenedor} ${fecha}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        ).then(() => {
          toggleEdit();
          Swal.fire('Good job!', 'Actualizado con exito', 'success');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
        });


      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: `${t('Status')}`, field: 'status', sortable: false },
    { name: `${t('No. Interno')}`, field: 'numeroInterno', sortable: true },
    { name: `${t('Consecutivo')}`, field: 'numero', sortable: true },
    { name: `${t('Numero BL')}`, field: 'numeroBl', sortable: true },
    { name: `${t('Pedimento')}`, field: 'pedimento', sortable: true },
    { name: `${t('Observaciones')}`, field: 'observaciones', sortable: false },
    { name: `${t('ETA')}`, field: 'etaReal', sortable: true },
    { name: `${t('Contenedor')}`, field: 'contenedor', sortable: true },
    { name: `${t('Naviera')}`, field: 'navieras', sortable: true },
    { name: `${t('Forwarder')}`, field: 'forwarders', sortable: true },
    { name: `${t('Agencia')}`, field: 'agencias', sortable: true },
    { name: `${t('Comisionista')}`, field: 'comisionistas', sortable: true },
    { name: `${t('Agente Aduanal')}`, field: 'agentes', sortable: true },
    { name: `${t('Modalidad')}`, field: 'modalidad', sortable: true },
    { name: `${t('Fecha Cita')}`,
      field: 'fechaCita',
      sortable: true,
      sortFunction: (rowA, rowB) => {
        const fechaA = rowA.fechaCita;
        const fechaB = rowB.fechaCita;
    
        // Si ambos están vacíos, se consideran iguales
        if (!fechaA && !fechaB) return 0;
        // Si uno está vacío, lo ubicamos al final (o al inicio, según lo que necesites)
        if (!fechaA) return 1;
        if (!fechaB) return -1;
    
        // Si ambos tienen valor, convertimos a fecha y comparamos
        return new Date(fechaA) - new Date(fechaB);
      }
    },
    { name: `${t('Transportista')}`, field: 'transportistas', sortable: false },
    {
      name: `${t('Entrega Cliente')}`,
      field: 'entregaCliente',
      sortable: true,
    },
    { name: `${t('Retorno')}`, field: 'retornoVacio', sortable: true },
    { name: `${t('Revalidacion')}`, field: 'revalidacion', sortable: true },
    // { name: `${t('Cliente')}`, field: 'clientes', sortable: true },
    { name: `${t('Archivos')}`, field: 'archivos', sortable: false },
    { name: `${t('Acciones')}`, field: 'acciones', sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.numeroInterno.toLowerCase().includes(search.toLowerCase()) ||
          comment.contenedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.numeroBl.toLowerCase().includes(search.toLowerCase()) ||
          comment.navieras.toLowerCase().includes(search.toLowerCase()) ||
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.agentes.toLowerCase().includes(search.toLowerCase()) ||
          comment.agencias.toLowerCase().includes(search.toLowerCase()) ||
          comment.comisionistas.toLowerCase().includes(search.toLowerCase()) ||
          comment.transportistas.toLowerCase().includes(search.toLowerCase()) ||
          comment.status.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.forwarders.toLowerCase().includes(search.toLowerCase()) ||
          comment.totalCantidad.toString().includes(search) ||
          comment.totalGeneral.toString().includes(search) ||
          comment.pedimento.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedNaviera) {
      computedComments = computedComments.filter((e) =>
        e.idNavieras.includes(selectedNaviera)
      );
    }

    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }

    if (selectedAgente) {
      computedComments = computedComments.filter((e) =>
        e.idAgentes.includes(selectedAgente)
      );
    }

    if (selectedAgencia) {
      computedComments = computedComments.filter((e) =>
        e.idAgencias.includes(selectedAgencia)
      );
    }

    if (selectedComisionista) {
      computedComments = computedComments.filter((e) =>
        e.idComisionistas.includes(selectedComisionista)
      );
    }

    if (selectedTransportista) {
      computedComments = computedComments.filter((e) =>
        e.idTransportistas.includes(selectedTransportista)
      );
    }

    if (selectedForwarder) {
      computedComments = computedComments.filter((e) =>
        e.idForwarders.includes(selectedForwarder)
      );
    }

    if (selectedPuerto) {
      computedComments = computedComments.filter((e) =>
        e.puerto.includes(selectedPuerto)
      );
    }

    if (selectedModalidad) {
      computedComments = computedComments.filter((e) =>
        e.modalidad.includes(selectedModalidad)
      );
    }
    if (selectedAsegurado) {
      computedComments = computedComments.filter((e) =>
        e.asegurado.includes(selectedAsegurado)
      );
    }

    if (selectedStatus) {
      computedComments = computedComments.filter((e) =>
        e.status.includes(selectedStatus)
      );
    }
    if (selectedRevalidacion) {
      computedComments = computedComments.filter((e) =>
        e.revalidacion.includes(selectedRevalidacion)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (selectedFechaCitaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fechaCita >= selectedFechaCitaInicio
      );
    }

    if (selectedFechaCitaFin) {
      computedComments = computedComments.filter(
        (e) => e.fechaCita <= selectedFechaCitaFin
      );
    }
    if (selectedPendiente) {
      computedComments = computedComments.filter((e) =>
        e.entregaCliente.includes(selectedPendiente)
      );
    }

    if (selectedActivo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(selectedActivo)
      );
    }


    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != 'totalCantidad' &&
      sorting.field != 'totalGeneral' &&
      sorting.field != 'pedimento' &&
      sorting.field != 'numero'
    ) {
      const reversed = sorting.order === 'asc' ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === 'asc' &&
      (sorting.field == 'totalCantidad' ||
        sorting.field == 'totalGeneral' ||
        sorting.field == 'pedimento' ||
        sorting.field == 'numero')
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === 'desc' &&
      (sorting.field == 'totalCantidad' ||
        sorting.field == 'totalGeneral' ||
        sorting.field == 'pedimento' ||
        sorting.field == 'numero')
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedFechaInicio,
    selectedFechaFin,
    selectedFechaCitaInicio,
    selectedFechaCitaFin,
    selectedNaviera,
    selectedCliente,
    selectedAgente,
    selectedAgencia,
    selectedComisionista,
    selectedTransportista,
    selectedForwarder,
    selectedPuerto,
    selectedModalidad,
    selectedAsegurado,
    selectedStatus,
    selectedRevalidacion,
    selectedPendiente,
    selectedActivo
  ]);

  async function EditArticulos(idOC, numeroContenedor) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: '',
        descripcion: '',
        cantidad: 0,
        precio: 0,
        total: 0,
      },
    ]);
    setIdEdit(idOC);
    setNumeroContenedor(numeroContenedor);
    await axios
      .get(`${URL_ARTICULOS_CONTENEDOR}/contenedor/${idOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
        },
      })
      .then((response) => {
        let allArticulosContenedor = response.data;
        let arrayTabla = allArticulosContenedor
          .map((a) => {
            return {
              id: a._id,
              articulos: a.articulos[0]._id,
              cantidad: a.cantidad,
              descripcion: a.descripcion,
              precio: a.precio,
              total: a.total,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        setArticulosContenedor(dataFinal);

        let cant = dataFinal.map((c) => parseFloat(c.cantidad));
        let TC = cant.reduce((t, total, index) => t + total, 0);
        setTotalCantidadEdit(TC);
        let importes = dataFinal.map((c) => parseFloat(c.total));
        let TG = importes.reduce((t, total, index) => t + total, 0);
        setTotalGeneralEdit(TG);
      })
      .catch((err) => {
        console.log(err);
      });
    toggleEditArticulos();
  }

  const handleChangeInputExistentes = (id, event) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  const handleChangeInputExistentesCantidad = (id, event) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  function BuscaArticuloExistentes(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        handleChangeInputExistentesArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputExistentesArticulo = (id, idArticulo) => {
    const newArticulosContenedor = articulosContenedor.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setArticulosContenedor(newArticulosContenedor);
    ActualizaTotales();
  };

  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: ultimo.articulos,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cantidadExistentes = articulosContenedor.map((c) =>
      parseFloat(c.cantidad)
    );
    let cantidadNuevos = values.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosContenedor.map((c) =>
      parseFloat(c.total)
    );
    let importesNuevos = values.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, event) {
    articulos.map((a) => {
      if (a._id == event.target.value) {
        let idArticulo = a._id;
        handleChangeInputArticulo(id, idArticulo);
      }
    });
  }

  const handleChangeInputArticulo = (id, idArticulo) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cantidadExistentes = articulosContenedor.map((c) =>
      parseFloat(c.cantidad)
    );
    let cantidadNuevos = inputFields.map((c) => parseFloat(c.cantidad));
    let cantidad = cantidadExistentes.concat(cantidadNuevos);
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalCantidadEdit(TC);

    let importesExistentes = articulosContenedor.map((c) =>
      parseFloat(c.total)
    );
    let importesNuevos = inputFields.map((c) => parseFloat(c.total));
    let importes = importesExistentes.concat(importesNuevos);
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneralEdit(TG);
  }

  const saveContenedor = async (event) => {
    event.preventDefault();
    toggleProgreso();

    let totalArticulos = inputFields.length + articulosContenedor.length;

    const URL_CONTENEDORES_EDIT = `${process.env.REACT_APP_URL_CONTENEDORES}/${idEdit}`;
    try {
      await axios
        .patch(
          URL_CONTENEDORES_EDIT,
          {
            totalGeneral: totalGeneral_edit,
            totalCantidad: totalCantidad_edit,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        )
        .then(() => {
          inputFields.map((a) => {
            if (a.articulos != '' && a.cantidad > 0) {
              axios
                .post(
                  URL_ARTICULOS_CONTENEDOR,
                  {
                    contenedores: idEdit,
                    articulos: a.articulos,
                    descripcion: a.descripcion,
                    cantidad: parseFloat(a.cantidad),
                    precio: parseFloat(a.precio),
                    total: parseFloat(a.total),
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem(
                        'app_token'
                      )}`,
                    },
                  }
                )
                .then(() => {
                  totalArticulos = totalArticulos - 1;
                  if (totalArticulos == 0) {
                    axios
                      .post(
                        URL_LOGS,
                        {
                          tipo: 'Editar Contenedor',
                          detalle: `${numeroContenedor}`,
                          user: user.id,
                        },
                        {
                          headers: {
                            Authorization: `Bearer: ${localStorage.getItem(
                              'app_token'
                            )}`,
                          },
                        }
                      )
                      .then(() => {
                        Swal.fire('Good job!', 'Creado con exito', 'success');
                        setTimeout(() => {
                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        Swal.fire({
                          icon: 'error',
                          title: 'Oops...',
                          text: 'Something went wrong!',
                          footer: `${error.response.data}`,
                        });
                        console.log(error);
                      });
                  }
                })
                .catch((error) => {
                  Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Something went wrong!',
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
              // cerrar if
            } else {
              totalArticulos = totalArticulos - 1;
              if (totalArticulos == 0) {
                axios
                  .post(
                    URL_LOGS,
                    {
                      tipo: 'Editar Contenedor',
                      detalle: `${numeroContenedor}`,
                      user: user.id,
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          'app_token'
                        )}`,
                      },
                    }
                  )
                  .then(() => {
                    Swal.fire('Good job!', 'Creado con exito', 'success');
                    setTimeout(() => {
                      window.location.reload();
                    }, 1000);
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: 'error',
                      title: 'Oops...',
                      text: 'Something went wrong!',
                      footer: `${error.response.data}`,
                    });
                    console.log(error);
                  });
              }
            }
          });

          articulosContenedor.map((a) => {
            axios
              .patch(
                `${URL_ARTICULOS_CONTENEDOR}/${a.id}`,
                {
                  articulos: a.articulos,
                  cantidad: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total),
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      'app_token'
                    )}`,
                  },
                }
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: 'Editar Contenedor',
                        detalle: `${numeroContenedor}`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem(
                            'app_token'
                          )}`,
                        },
                      }
                    )
                    .then(() => {
                      Swal.fire('Good job!', 'Creado con exito', 'success');
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Something went wrong!',
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: 'error',
                  title: 'Oops...',
                  text: 'Something went wrong!',
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
        footer: `${error.response.data}`,
      });
      console.log(error);
    }
  };

  function EditStatus(
    id,
    bl,
    pl,
    factura,
    numeroInterno,
    documentos,
    telex,
    toquePiso,
    libreAlmacenajes,
    revalidacion,
    fichaTecnica,
    pagoPedimento,
    modulacion,
    retornoVacio,
    salidaPuerto,
    salidaRuta,
    // maniobras,
    entregaCliente,
    status,
    fechaEntradaPuerto,
    fechaDocumentos,
    fechaTelex,
    fechaToquePiso,
    fechaLibreAlmacenajes,
    fechaRevalidacion,
    fechaFichaTecnica,
    fechaPagoPedimento,
    fechaModulacion,
    fechaRetornoVacio,
    fechaSalidaPuerto,
    fechaSalidaRuta,
    // fechaManiobras,
    fechaEntregaCliente,
    fechaFactura,
    fechaBl,
    fechaPl,

    fechaAtraco,
    fechaCartaEncomienda,
    fechaOtrosDocumentos,
    fechaArchivoPendientes,
    fechaBLRevalidado,
    fechaClasificado,
    fechaCarta318,
    fechaProformaPedimento,
    archivoAtraco,
    archivoCartaEncomienda,
    archivoOtrosDocumentos,
    archivoArchivoPendientes,
    archivoBLRevalidado,
    archivoClasificado,
    archivoCarta318,
    archivoProformaPedimento
  ) {
    setid(id);
    setbl(bl);
    setpl(pl);
    setfactura(factura);
    setnumeroInterno(numeroInterno);
    setdocumentos(documentos);
    settelex(telex);
    settoquePiso(toquePiso);
    setLibreAlmacenajes(libreAlmacenajes);
    setrevalidacion(revalidacion);
    setfichaTecnica(fichaTecnica);
    setpagoPedimento(pagoPedimento);
    setmodulacion(modulacion);
    setretornoVacio(retornoVacio);
    setsalidaPuerto(salidaPuerto);
    setsalidaRuta(salidaRuta);
    // setmaniobras(maniobras)
    setentregaCliente(entregaCliente);
    setstatus(status);
    setfechaEntradaPuerto(fechaEntradaPuerto);
    setfechaDocumentos(fechaDocumentos);
    setfechaTelex(fechaTelex);
    setfechaToquePiso(fechaToquePiso);
    setfechaLibreAlmacenajes(fechaLibreAlmacenajes);
    setfechaRevalidacion(fechaRevalidacion);
    setfechaFichaTecnica(fechaFichaTecnica);
    setfechaPagoPedimento(fechaPagoPedimento);
    setfechaModulacion(fechaModulacion);
    setfechaRetornoVacio(fechaRetornoVacio);
    setfechaSalidaPuerto(fechaSalidaPuerto);
    setfechaSalidaRuta(fechaSalidaRuta);
    // setfechaManiobras(fechaManiobras)
    setfechaEntregaCliente(fechaEntregaCliente);
    setfechaFactura(fechaFactura);
    setfechaBl(fechaBl);
    setfechaPl(fechaPl);

    setFechaAtraco(fechaAtraco);
    setFechaCartaEncomienda(fechaCartaEncomienda);
    setFechaOtrosDocumentos(fechaOtrosDocumentos);
    setFechaArchivoPendientes(fechaArchivoPendientes);
    setFechaBlRevalidado(fechaBLRevalidado);
    setFechaClasificado(fechaClasificado);
    setFechaCarta318(fechaCarta318);
    setFechaProformaPedimento(fechaProformaPedimento);

    setDatoArchivoAtraco(archivoAtraco);
    setDatoArchivoCartaEncomienda(archivoCartaEncomienda);
    setDatoArchivoOtrosDocumentos(archivoOtrosDocumentos);
    setDatoArchivoArchivoPendientes(archivoArchivoPendientes);
    setDatoArchivoBLRevalidado(archivoBLRevalidado);
    setDatoArchivoClasificado(archivoClasificado);
    setDatoArchivoCarta318(archivoCarta318);
    setDatoArchivoProformaPedimento(archivoProformaPedimento);
    toggleStatus();
  }

  function updateStatus(property, value, nombreFecha, fechaS) {
    if (fechaS == '' || fechaS == undefined) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'La fecha no puede estar vacia',
      });
    } else {
      const data = {
        [property]: value,
        [nombreFecha]: fechaS,
        status,
      };

      axios
        .patch(`${URL_CONTENEDORES}/${id}`, data, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        })
        .then(() => {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Actualizado con Exito',
            showConfirmButton: false,
            timer: 2000,
          });

          let temp = comments.map((a) => {
            if (a._id === id) {
              a[nombreFecha] = fechaS;
              a[property] = value;
              a.status = status;
            }
            return a;
          });
          setComments(temp);
        //     setTimeout(() => {
        //   window.location.reload();
        // }, 1000);
        })
        .catch((error) => {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Something went wrong!',
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
    }
  }

  function updateOnlyStatus() {
    axios
      .patch(
        `${URL_CONTENEDORES}/${id}`,
        {
          status,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Actualizado con Exito',
          showConfirmButton: false,
          timer: 2000,
        });

        let temp = comments.map((a) => {
          if (a._id === id) {
            a.status = status;
          }
          return a;
        });
        setComments(temp);

        setTimeout(() => {
          setModalStatus(false);
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const calcula = (e) => {
    setTotalUSD(e);
    setTotal(parseFloat(e) * parseFloat(tipoCambio));
  };

  const calculaTipoCambio = (e) => {
    setTipoCambio(e);
    setTotal(parseFloat(totalUSD) * parseFloat(e));
  };

  function saveGasto() {
    setValidaBoton(false);
    axios
      .post(
        URL_GASTOS_CONTENEDOR,
        {
          fecha: fechaGasto,
          totalUSD,
          tipoCambio,
          total,
          abonos: 0,
          saldo: total,
          descripcion,
          conceptosGastos: selectedConcepto,
          contenedores: selectedContenedor,
          proveedores: selectedProveedor,
          clientes: selectedClienteGasto,
          moneda,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: 'Crear Gasto',
            detalle: `Fecha: ${fecha} / Concepto: ${selectedConcepto} / Total: ${total} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        );
        Swal.fire('Good job!', 'Creado con exito', 'success');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

  function saveCargo() {
    setValidaBoton(false);
    axios
      .post(
        URL_CARGOS_CONTENEDOR,
        {
          fecha: fechaGasto,
          totalUSD,
          tipoCambio,
          total,
          abonos: 0,
          saldo: total,
          descripcion,
          conceptosGastos: selectedConcepto,
          contenedores: selectedContenedor,
          clientes: selectedClienteGasto,
          moneda,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: 'Crear Cargo',
            detalle: `Fecha: ${fecha} / Concepto: ${selectedConcepto} / Total: ${total} `,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem('app_token')}`,
            },
          }
        );
        Swal.fire('Good job!', 'Creado con exito', 'success');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Something went wrong!',
        });
        console.log(error);
        setValidaBoton(true);
      });
  }

  function excelOC() {
    var option = {};

    option.fileName = numeroInterno;

    option.datas = [
      {
        sheetData: [
          {
            BL: fechaBl,
            PL: fechaPl,
            Factura: fechaFactura,
            FichaTecnica: fechaFichaTecnica,
            Telex: fechaTelex,
            ToquePiso: fechaToquePiso,
            Revalidacion: fechaRevalidacion,
            PagoPedimento: fechaPagoPedimento,
            Documentos: fechaDocumentos,
            Modulacion: fechaModulacion,
            SalidaDespacho: fechaSalidaPuerto,
            SalidaRuta: fechaSalidaRuta,
            // Maniobras: fechaManiobras,
            EntregaCliente: fechaEntregaCliente,
            RetornoVacio: fechaRetornoVacio,
          },
        ],
        sheetName: numeroInterno,
        sheetFilter: [
          'BL',
          'PL',
          'Factura',
          'FichaTecnica',
          'Telex',
          'ToquePiso',
          'Revalidacion',
          'PagoPedimento',
          'Documentos',
          'Modulacion',
          'SalidaDespacho',
          'SalidaRuta',
          // 'Maniobras',
          'EntregaCliente',
          'RetornoVacio',
        ],
        sheetHeader: [
          'BL',
          'PL',
          'Factura',
          'FichaTecnica',
          'Telex',
          'ToquePiso',
          'Revalidacion',
          'PagoPedimento',
          'Documentos',
          'Modulacion',
          'SalidaDespacho',
          'SalidaRuta',
          // 'Maniobras',
          'EntregaCliente',
          'RetornoVacio',
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

//   async function registrarSG(id, naviera, contenedor) {

//     axios
//     .patch(
//       `${URL_CONTENEDORES}AltaRastreo/${id}`,
//       {
//         navieras: naviera,
//         contenedor: contenedor
//       },
//       {
//         headers: {
//           Authorization: `Bearer: ${localStorage.getItem(
//             'app_token'
//           )}`,
//         },
//       }
//     )
//     .then(() => {
//       Swal.fire('Good job!', 'Creado con exito', 'success');
//       setTimeout(() => {
//         window.location.reload();
//       }, 1000);
//     })
//     .catch((error) => {
//       Swal.fire({
//         icon: 'error',
//         title: 'Oops...',
//         text: 'Something went wrong!',
//         footer: `${error.response.data}`,
//       });
//       console.log(error);
//     });
    
//   }

//   function crearMapa(polLatitude,
//     polLongitude,
//     podLatitude,
//     podLongitude,
//     vesselLatitude,
//     vesselLongitude,
//     etaReal
//   ){

// const etaRealDate = new Date(etaReal)
// etaRealDate.setHours(0, 0, 0, 0);
// hoy.setHours(0, 0, 0, 0);
//   const diasDiferencia = Math.floor((Date.UTC(etaRealDate.getFullYear(), etaRealDate.getMonth(), etaRealDate.getDate()) - 
//                                    Date.UTC(hoy.getFullYear(), hoy.getMonth(), hoy.getDate())) / (1000 * 60 * 60 * 24));

//     setDiasLlegada(diasDiferencia)

//     setOriginCoords([polLatitude, polLongitude]);  // Ningbo, China (puerto de origen)
//     setVesselCoords([vesselLatitude, vesselLongitude]);  // Posición actual del barco
//     setDestinationCoords([podLatitude, podLongitude]);  // Lázaro Cárdenas, México (puerto de destino)
  
//     // Ruta con puntos intermedios
//     setCoordenadasMapa([
//       // [polLatitude, polLongitude], 
//       [vesselLatitude, vesselLongitude], 
//       [podLatitude, podLongitude],
//       // [30, 140],  // Punto intermedio 1 en el océano
//       // [40, -160],
//       // [20, -130],  // Punto intermedio 2 en el océano
//     ]);

//     toggleMapa()
//   }

  // Foto Atraco
  function guardaFotosAtraco() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_ATRACO, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              archivoAtraco: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");

                setArchivoAtraco("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoAtraco(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_ATRACO}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoAtraco();
  }

  // Foto Toque Piso
  function guardaFotosToquePiso() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_TOQUEPISO, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              archivoToquePiso: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");

                setArchivoToquePiso("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoToquePiso(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_TOQUEPISO}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoToquePiso();
  }

  // Foto Carta Encomienda
  function guardaFotosCartaEncomienda() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_CARTAENCOMIENDA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              archivoCartaEncomienda: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");

                setArchivoCartaEncomienda("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoCartaEncomienda(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_CARTAENCOMIENDA}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
  setPhoto(Array.isArray(res.data?.resources) ? res.data.resources : []);
})
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoCartaEncomienda();
  }

   // Foto Otros Documentos
  function guardaFotosOtrosDocumentos() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_OTROSDOCUMENTOS, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              archivoOtrosDocumentos: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");

                setArchivoOtrosDocumentos("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoOtrosDocumentos(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_OTROSDOCUMENTOS}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoOtrosDocumentos();
  }

   // Foto Archivo Pendientes
  function guardaFotosArchivoPendientes() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_ARCHIVOPENDIENTES, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              archivoArchivoPendientes: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");

                setArchivoArchivoPendientes("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoArchivoPendientes(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_ARCHIVOPENDIENTES}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoArchivoPendientes();
  }


   // Foto BL Revalidado
  function guardaFotosBLRevalidado() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_BLREVALIDADO, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              archivoBLRevalidado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");

                setArchivoBLRevalidado("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoBLRevalidado(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_BLREVALIDADO}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoBLRevalidado();
  }


   // Foto Clasificado
  function guardaFotosClasificado() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_CLASIFICADO, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              archivoClasificado: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");

                setArchivoClasificado("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoClasificado(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_CLASIFICADO}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoClasificado();
  }


   // Foto Carta 318
  function guardaFotosCarta318() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_CARTA318, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              archivoCarta318: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");

                setArchivoCarta318("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoCarta318(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_CARTA318}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoCarta318();
  }


   // Foto Proforma Pedimento
  function guardaFotosProformaPedimento() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_PROFORMAPEDIMENTO, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              archivoProformaPedimento: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");

                setArchivoProformaPedimento("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoProformaPedimento(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_PROFORMAPEDIMENTO}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoProformaPedimento();
  }

  // Foto Packing
  function guardaFotosPacking() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_PACKING, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              packing: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");

                setPacking("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoPacking(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_PACKING}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoPacking();
  }

    // Foto BL
    function guardaFotosBL() {
      file.map((a)=>{
      const formData = new FormData();
      formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
      formData.append("contenedor", idContenedor);
    
      axios
        .post(URL_UPMEDIA_BL, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
          },
          params: {
            resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
          },
        })
        .then((response) => {
          axios
            .patch(
              `${URL_CONTENEDORES}/${idContenedor}`,
              {
                bl: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Contenedor",
                    detalle: `Subir Foto`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire("Good job!", "Actualizado con éxito", "success");
                  setBlArchivo("Si");
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
      })
      setFile();
      setPhoto([]);
    }
  
    function jalaFotoBL(idCont) {
      setPhoto([])
      const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_BL}/${idCont}`;
      axios
        .get(URL_GET_MEDIA, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => {
          setPhoto(data.data.resources);
          
        })
        .catch((err) => console.log(err));
      setIdContenedor(idCont);
  
  
      toggleFotoBL();
    }

      // Foto Invoice
  function guardaFotosInvoice() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_INVOICE, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              invoice: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setInvoice("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoInvoice(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_INVOICE}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoInvoice();
  }

        // Foto FichaTecnica
        function guardaFotosFichaTecnica() {
          file.map((a)=>{
          const formData = new FormData();
          formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
          formData.append("contenedor", idContenedor);
        
          axios
            .post(URL_UPMEDIA_FICHA_TECNICA, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
              },
              params: {
                resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
              },
            })
            .then((response) => {
              axios
                .patch(
                  `${URL_CONTENEDORES}/${idContenedor}`,
                  {
                    fichaTecnicaArchivo: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Contenedor",
                        detalle: `Subir Foto`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      }
                    )
                    .then((response) => {
                      Swal.fire("Good job!", "Actualizado con éxito", "success");
                      setFichaTecnicaArchivo("Si");
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
          })
          setFile();
          setPhoto([]);
        }
      
        function jalaFotoFichaTecnica(idCont) {
          setPhoto([])
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_FICHA_TECNICA}/${idCont}`;
          axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              setPhoto(data.data.resources);
              
            })
            .catch((err) => console.log(err));
          setIdContenedor(idCont);
      
      
          toggleFotoFichaTecnica();
        }


              // Foto Cargos Locales
  function guardaFotosCargosLocales() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_CARGOS_LOCALES, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              cargosLocales: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setCargosLocales("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoCargosLocales(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_CARGOS_LOCALES}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoCargosLocales();
  }

        // Foto DODA
        function guardaFotosDODA() {
          file.map((a)=>{
          const formData = new FormData();
          formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
          formData.append("contenedor", idContenedor);
        
          axios
            .post(URL_UPMEDIA_DODA, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
              },
              params: {
                resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
              },
            })
            .then((response) => {
              axios
                .patch(
                  `${URL_CONTENEDORES}/${idContenedor}`,
                  {
                    DODA: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Contenedor",
                        detalle: `Subir Foto`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      }
                    )
                    .then((response) => {
                      Swal.fire("Good job!", "Actualizado con éxito", "success");
                      setDODA("Si");
                      // PackingsetTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
          })
          setFile();
          setPhoto([]);
        }
      
        function jalaFotoDODA(idCont) {
          setPhoto([])
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_DODA}/${idCont}`;
          axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              setPhoto(data.data.resources);
              
            })
            .catch((err) => console.log(err));
          setIdContenedor(idCont);
      
      
          toggleFotoDODA();
        }

              // Foto Boleta
  function guardaFotosBoleta() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_BOLETA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              boleta: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setBoleta("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoBoleta(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_BOLETA}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoBoleta();
  }

        // Foto Prealta
        function guardaFotosPrealta() {
          file.map((a)=>{
          const formData = new FormData();
          formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
          formData.append("contenedor", idContenedor);
        
          axios
            .post(URL_UPMEDIA_PREALTA, formData, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
              },
              params: {
                resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
              },
            })
            .then((response) => {
              axios
                .patch(
                  `${URL_CONTENEDORES}/${idContenedor}`,
                  {
                    prealta: "Si",
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Contenedor",
                        detalle: `Subir Foto`,
                        user: user.id,
                      },
                      {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      }
                    )
                    .then((response) => {
                      Swal.fire("Good job!", "Actualizado con éxito", "success");
                      setPrealta("Si");
                      // setTimeout(() => {
                      //   window.location.reload();
                      // }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                    });
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
          })
          setFile();
          setPhoto([]);
        }
      
        function jalaFotoPrealta(idCont) {
          setPhoto([])
          const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_PREALTA}/${idCont}`;
          axios
            .get(URL_GET_MEDIA, {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            })
            .then((data) => {
              setPhoto(data.data.resources);
              
            })
            .catch((err) => console.log(err));
          setIdContenedor(idCont);
      
      
          toggleFotoPrealta();
        }

              // Foto EIR
  function guardaFotosEIR() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_EIR, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              EIR: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setEIR("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoEIR(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_EIR}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoEIR();
  }
    // Foto Validacion
    function guardaFotosValidacion() {
      file.map((a)=>{
      const formData = new FormData();
      formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
      formData.append("contenedor", idContenedor);
    
      axios
        .post(URL_UPMEDIA_VALIDACION, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
          },
          params: {
            resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
          },
        })
        .then((response) => {
          axios
            .patch(
              `${URL_CONTENEDORES}/${idContenedor}`,
              {
                validacion: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Contenedor",
                    detalle: `Subir Foto`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire("Good job!", "Actualizado con éxito", "success");
                  setValidacion("Si");
                  // setTimeout(() => {
                  //   window.location.reload();
                  // }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
      })
      setFile();
      setPhoto([]);
    }
  
    function jalaFotoValidacion(idCont) {
      setPhoto([])
      const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_VALIDACION}/${idCont}`;
      axios
        .get(URL_GET_MEDIA, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => {
          setPhoto(data.data.resources);
          
        })
        .catch((err) => console.log(err));
      setIdContenedor(idCont);
  
  
      toggleFotoValidacion();
    }

      // Foto Garantia
  function guardaFotosGarantia() {
    file.map((a)=>{
    const formData = new FormData();
    formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
    formData.append("contenedor", idContenedor);
  
    axios
      .post(URL_UPMEDIA_GARANTIA, formData, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
        },
        params: {
          resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
        },
      })
      .then((response) => {
        axios
          .patch(
            `${URL_CONTENEDORES}/${idContenedor}`,
            {
              garantia: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then((response) => {
            axios
              .post(
                URL_LOGS,
                {
                  tipo: "Contenedor",
                  detalle: `Subir Foto`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              )
              .then((response) => {
                Swal.fire("Good job!", "Actualizado con éxito", "success");
                setGarantia("Si");
                // setTimeout(() => {
                //   window.location.reload();
                // }, 1000);
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
              });
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
    })
    setFile();
    setPhoto([]);
  }

  function jalaFotoGarantia(idCont) {
    setPhoto([])
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_GARANTIA}/${idCont}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        setPhoto(data.data.resources);
        
      })
      .catch((err) => console.log(err));
    setIdContenedor(idCont);


    toggleFotoGarantia();
  }

    // Foto Transporte
    function guardaFotosTransporte() {
      file.map((a)=>{
      const formData = new FormData();
      formData.append("file", a); // El archivo puede ser imagen, PDF, o Excel
      formData.append("contenedor", idContenedor);
    
      axios
        .post(URL_UPMEDIA_TRANSPORTE, formData, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "multipart/form-data", // Asegura que el tipo de contenido sea correcto
          },
          params: {
            resource_type: "raw", // Para Cloudinary, permite la subida de archivos que no son imágenes
          },
        })
        .then((response) => {
          axios
            .patch(
              `${URL_CONTENEDORES}/${idContenedor}`,
              {
                transporte: "Si",
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            )
            .then((response) => {
              axios
                .post(
                  URL_LOGS,
                  {
                    tipo: "Contenedor",
                    detalle: `Subir Foto`,
                    user: user.id,
                  },
                  {
                    headers: {
                      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    },
                  }
                )
                .then((response) => {
                  Swal.fire("Good job!", "Actualizado con éxito", "success");
                  setTransporte("Si");
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
                })
                .catch((error) => {
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                    footer: `${error.response.data}`,
                  });
                  console.log(error);
                });
            })
            .catch((error) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
                footer: `${error.response.data}`,
              });
              console.log(error);
            });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            footer: `${error.response.data}`,
          });
          console.log(error);
        });
      })
      setFile();
      setPhoto([]);
    }
  
    function jalaFotoTransporte(idCont) {
      setPhoto([])
      const URL_GET_MEDIA = `${process.env.REACT_APP_URL_FINDMEDIABYTAG_TRANSPORTE}/${idCont}`;
      axios
        .get(URL_GET_MEDIA, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((data) => {
          setPhoto(data.data.resources);
          
        })
        .catch((err) => console.log(err));
      setIdContenedor(idCont);
  
  
      toggleFotoTransporte();
    }
    function borrarFoto(id) {

      axios.post(`${URL_DELMEDIA}/${id}`, {}, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
  
      .then(() => {
  
        Swal.fire("Good job!", "Actualizado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
  
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
      
  
      // setFile();
      // setPhoto([]);
    }

    function jalaArchivos(
      id,
      packing,
      bl,
      invoice,
      fichaTecnicaArchivo,
      cargosLocales,
      DODA,
      boleta,
      prealta,
      EIR,
      validacion,
      garantia,
      transporte,
      archivoAtraco,
      archivoCartaEncomienda,
      archivoOtrosDocumentos,
      archivoArchivoPendientes,
      archivoBLRevalidado,
      archivoClasificado,
      archivoCarta318,
      archivoProformaPedimento
    ) {
      setIdContenedor(id);
      setPacking(packing);
      setBlArchivo(bl);
      setInvoice(invoice);
      setFichaTecnicaArchivo(fichaTecnicaArchivo);
      setCargosLocales(cargosLocales);
      setDODA(DODA);
      setBoleta(boleta);
      setPrealta(prealta);
      setEIR(EIR);
      setValidacion(validacion);
      setGarantia(garantia);
      setTransporte(transporte);
      setArchivoAtraco(archivoAtraco);
      setArchivoCartaEncomienda(archivoCartaEncomienda);
      setArchivoOtrosDocumentos(archivoOtrosDocumentos);
      setArchivoArchivoPendientes(archivoArchivoPendientes);
      setArchivoBLRevalidado(archivoBLRevalidado);
      setArchivoClasificado(archivoClasificado);
      setArchivoCarta318(archivoCarta318);
      setArchivoProformaPedimento(archivoProformaPedimento);
      toggleFotos();
    }

    function ObservacionesCell({ texto, rowId }) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

  const truncated =
    texto && texto.length > 20 ? texto.substring(0, 20) + "..." : texto;

  return (
    <>
      <td
        id={`obs-${rowId}`} // ID único para el tooltip
        style={{ paddingTop: "0px" }}
      >
        {truncated}
      </td>
      <Tooltip
        placement="top"
        isOpen={tooltipOpen}
        target={`obs-${rowId}`}
        toggle={toggle}
      >
        {texto}
      </Tooltip>
    </>
  );
}

const guardarPedimento = async () => {
  if (!nuevoPedimento.trim()) {
    Swal.fire("Falta número", "Debes escribir el número de pedimento", "warning");
    return;
  }
console.log("URL PEDIMENTO =>", `${URL_CONTENEDORES}/${selectedContenedor._id}/pedimento`);
  try {
    setLoadingPedimento(true);

    const headers = {
      Authorization: `Bearer ${localStorage.getItem("app_token")}`,
    };

    const res = await axios.patch(
      `${URL_CONTENEDORES}/${selectedContenedor._id}/pedimento`,
      {
        numero: nuevoPedimento,
        observaciones: obsPedimento,
      },
      { headers }
    );

    // 🔄 actualizar pedimentos en pantalla sin recargar todo
    setSelectedContenedor(res.data.contenedor);

    // limpiar campos
    setNuevoPedimento("");
    setObsPedimento("");

    Swal.fire("Listo", "Pedimento agregado correctamente", "success");
  } catch (err) {
    console.error(err);
    Swal.fire("Error", err.response?.data?.msg || "No se pudo guardar", "error");
  } finally {
    setLoadingPedimento(false);
  }
};


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menuContenedores ? (
        <div className='card col-12'>
          <Row>
            <Col md={8}>
              {user.contenedoresCreate ? (
                <Button
                  size='sm'
                  type='submit'
                  className='btn btn-success'
                  href='/ContenedoresCreate'
                >
                  {t('Nuevo')}
                </Button>
              ) : (
                <Button
                  size='sm'
                  type='submit'
                  className='btn btn-success'
                  disabled
                >
                  {t('Nuevo')}
                </Button>
              )}
              <Button
                size='sm'
                href='/MenuContenedores'
                className='btn btn-danger'
                id='botonListado'
              >
                {t('Regresar')}
              </Button>
            </Col>
            <Col sm={4}>
<ButtonGroup id="logoutBoton" className="gap-1">
  <Button id="btnPdfGeneral" size="sm" color="danger" onClick={PDFTabla}>
    <i className="far fa-file-pdf"></i>
  </Button>
  <UncontrolledTooltip target="btnPdfGeneral" placement="bottom">
    PDF General
  </UncontrolledTooltip>

  <Button id="btnPdfCliente" size="sm" color="warning" onClick={PDFTablaCliente}>
    <i className="far fa-file-pdf"></i>
  </Button>
  <UncontrolledTooltip target="btnPdfCliente" placement="bottom">
    PDF Cliente
  </UncontrolledTooltip>

  <Button id="btnPdfPiso" size="sm" color="secondary" onClick={PDFTablaPiso}>
    <i className="fas fa-warehouse"></i>
  </Button>
  <UncontrolledTooltip target="btnPdfPiso" placement="bottom">
    PDF En Piso
  </UncontrolledTooltip>

  <Button id="btnPdfEir" size="sm" color="info" onClick={PDFTablaEIR}>
    <i className="fas fa-ship"></i>
  </Button>
  <UncontrolledTooltip target="btnPdfEir" placement="bottom">
    PDF EIR
  </UncontrolledTooltip>

  {user?.menuReportes && (
  <>
    <Button
      id="btnPdfArribar"
      size="sm"
      color="success"
      onClick={PDFTablaPorArribar}
    >
      <i className="fas fa-plane-arrival"></i>
    </Button>
    <UncontrolledTooltip target="btnPdfArribar" placement="bottom">
      PDF Por Arribar
    </UncontrolledTooltip>
  </>
)}


  <Button id="btnExcel" size="sm" color="primary" onClick={excel}>
    <i className="far fa-file-excel"></i>
  </Button>
  <UncontrolledTooltip target="btnExcel" placement="bottom">
    Exportar Excel
  </UncontrolledTooltip>
</ButtonGroup>

            </Col>
          </Row>
          <Modal size='sm' isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>{t('Enviar Listado Contenedores')}</h4>
            </ModalHeader>
            <ModalBody>
              <Label className='mr-sm-2'>Email</Label>
              <Input
                className='col-sm-12'
                type='text'
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size='sm' color='success' onClick={enviaMail}>
                {t('Enviar')}
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align='center'>{t('Contenedores')}</h3>
          <div className='row'>
            <div className='col-md-8'>
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className='col-md-4 d-flex flex-row-reverse'>
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Fecha Inicio')}</Label>
              <Input
                bsSize='sm'
                type='date'
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Fecha Fin')}</Label>
              <Input
                bsSize='sm'
                type='date'
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>

            <Col md={2}>
              <Label className='mr-sm-2'>{t('Pendientes')}</Label>
              <Input
                bsSize='sm'
                type='select'
                value={selectedPendiente}
                required
                onChange={(e) => {
                  setSelectedPendiente(e.target.value);
                }}
              >
                <option value=''>{t('Selecciona')}</option>
                <option value='No'>{t('Pendiente')}</option>
                <option value='Si'>{t('Entregado')}</option>
              </Input>
            </Col>

            <Col md={2}>
              <Label className='mr-sm-2'>{t('Activo')}</Label>
              <Input
                bsSize='sm'
                type='select'
                value={selectedActivo}
                required
                onChange={(e) => {
                  setSelectedActivo(e.target.value);
                }}
              >
                <option value=''>{t('Selecciona')}</option>
                <option value='Si'>{t('Activo')}</option>
                <option value='No'>{t('Cancelado')}</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Fecha Cita Inicio')}</Label>
              <Input
                bsSize='sm'
                type='date'
                value={selectedFechaCitaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaCitaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Fecha Cita Fin')}</Label>
              <Input
                bsSize='sm'
                type='date'
                value={selectedFechaCitaFin}
                required
                onChange={(e) => {
                  setSelectedFechaCitaFin(e.target.value);
                }}
              />
            </Col>

          </Row>
          <br />
          <div className="contenedores-wrapper">
          <Table size='sm' striped borderless className='table-responsive-xl contenedores-table'>
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>


              <td style={{ paddingTop: '0px' }}>
                <Input
                  type='select'
                  bsSize='sm'
                  value={selectedStatus}
                  onChange={(e) => {
                    setSelectedStatus(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>Selecciona</option>
                  <option value='En Transito'>En Transito</option>
                  <option value='Arribo'>Arribo</option>
                  <option value='En Piso'>En Piso</option>
                  <option value='Cita Obtenida'>Cita Obtenida</option>
                  <option value='Desaduanado'>Desaduanado</option>
                  <option value='Maniobras de Vacio'>Maniobras de Vacio</option>
                  <option value='Entrega Cliente Final'>Entrega Cliente Final</option>
                  <option value='Falta EIR'>Falta EIR</option>
                  <option value='Finalizado'>Finalizado</option>
                  <option value='Pendiente'>Pendiente</option>
                  <option value='Cancelado'>Cancelado</option>
                  <option value='Cancelado Con Pend'>Cancelado Con Pend</option>
                  <option value='Retenido Por Aduana'>Retenido Por Aduana</option>
                  <option value='Abandono'>Abandono</option>
                </Input>
              </td>

              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedCliente}
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td> 
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedNaviera}
                  onChange={(e) => {
                    setSelectedNaviera(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Naviera') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedForwarder}
                  onChange={(e) => {
                    setSelectedForwarder(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Forwarder') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedAgencia}
                  onChange={(e) => {
                    setSelectedAgencia(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Agencia') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedComisionista}
                  onChange={(e) => {
                    setSelectedComisionista(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Comisionista') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedAgente}
                  onChange={(e) => {
                    setSelectedAgente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Agente') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  placeholder='Modalidad'
                  value={selectedModalidad}
                  required
                  onChange={(e) => {
                    setSelectedModalidad(e.target.value);
                  }}
                >
                  <option value=''>Selecciona</option>
                  <option value='Tren'>Tren</option>
                  <option value='Camion'>Camion</option>
                </Input>
              </td>
             
              <td></td>
              {/* <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  placeholder='Asegurado'
                  value={selectedAsegurado}
                  required
                  onChange={(e) => {
                    setSelectedAsegurado(e.target.value);
                  }}
                >
                  <option value=''>Selecciona</option>
                  <option value='No'>No</option>
                  <option value='Si'>Si</option>
                  <option value='No Aplica'>No Aplica</option>
                </Input>
              </td> */}
              {/* <td></td> */}
              <td style={{ paddingTop: '0px' }}>
                <Input
                  bsSize='sm'
                  type='select'
                  value={selectedTransportista}
                  onChange={(e) => {
                    setSelectedTransportista(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>{t('Selecciona')}</option>
                  {proveedores
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      if (a.tipo === 'Transportista') {
                        return <option value={a._id}>{a.name}</option>;
                      }
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: '0px' }}></td>
              <td style={{ paddingTop: '0px' }}></td>
              <td style={{ paddingTop: '0px' }}>
                <Input
                  type='select'
                  bsSize='sm'
                  value={selectedRevalidacion}
                  onChange={(e) => {
                    setSelectedRevalidacion(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value=''>Selecciona</option>
                  <option value='Si'>Si</option>
                  <option value='No'>No</option>
                </Input>
              </td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                // const getRowStyle = (a) => {
                //   // Si está entregado o en retorno vacío, prioridad
                //   if (a.status === "Cancelado" || a.status === "Retenido Por Aduana") {
                //     return { backgroundColor: "#e18c8cff" };
                //   }
                //   if (a.status === "En Transito") {
                //     return { backgroundColor: "#7184dfff" };
                //   }
                //   if (a.status === "Arribo" || a.status === "En Piso") {
                //     return { backgroundColor: "#dd9950ff" };
                //   }
                //   if (a.status === "Cita Obtenida") {
                //     return { backgroundColor: "#eeec57ff" };
                //   }
                //   if (a.status === "Desaduanado" || a.status === "Maniobras de Vacio" || a.status === "Entrega Cliente Final" || a.status === "Falta EIR") {
                //     return { backgroundColor: "#88cdedff" };
                //   }
                //   if (a.status === "Finalizado") {
                //     return { backgroundColor: "#3bcb47ff" };
                //   }
                // };

                const getStatusStyle = (status) => {
    if (status === "Cancelado" || status === "Retenido Por Aduana" || status === "Cancelado Con Pend") {
      return { backgroundColor: "#e18c8cff" };
    }
    if (status === "En Transito") {
      return { backgroundColor: "#7184dfff" };
    }
    if (status === "Arribo" || status === "En Piso") {
      return { backgroundColor: "#dd9950ff" };
    }
    if (status === "Cita Obtenida") {
      return { backgroundColor: "#eeec57ff" };
    }
    if (
      status === "Desaduanado" ||
      status === "Maniobras de Vacio" ||
      status === "Entrega Cliente Final" ||
      status === "Falta EIR"
    ) {
      return { backgroundColor: "#88cdedff" };
    }
    if (status === "Finalizado") {
      return { backgroundColor: "#3bcb47ff" };
    }
    return {};
  };
                
                return (
                  <tr key={a._id}>
                    {/* <td>{a.numero}</td>
                    <td>{a.fecha}</td> */}
                    <td
                      className="sticky-col"
                      style={{ paddingTop: "0px", ...getStatusStyle(a.status) }}
                    >
                      {a.status}
                    </td>
                    <td className="sticky-col" style={{ paddingTop: "0px" }}>
                      {a.numeroInterno}
                    </td>
                    <td className="sticky-col" style={{ paddingTop: "0px" }}>
                      {a.numero}
                    </td>
                    <td className="sticky-col" style={{ paddingTop: "0px" }}>
                      {a.numeroBl}
                    </td>
                    <td className="sticky-col" style={{ paddingTop: "0px" }}>
                      {a.pedimento}
                    </td>
                    <td className="sticky-col" style={{ paddingTop: "0px" }}>
                      <ObservacionesCell
                        texto={a.observaciones}
                        rowId={a._id}
                      />
                    </td>
                    <td className="sticky-col" style={{ paddingTop: "0px" }}>
                      {a.etaReal}
                    </td>
                    <td style={{ paddingTop: "0px" }}>{a.contenedor}</td>
                    <td style={{ paddingTop: "0px" }}>{a.navieras}</td>
                    <td style={{ paddingTop: "0px" }}>{a.forwarders}</td>
                    <td style={{ paddingTop: "0px" }}>{a.agencias}</td>
                    <td style={{ paddingTop: "0px" }}>{a.comisionistas}</td>
                    <td style={{ paddingTop: "0px" }}>{a.agentes}</td>
                    <td style={{ paddingTop: "0px" }}>{a.modalidad}</td>
                    <td style={{ paddingTop: "0px" }}>{a.fechaCita}</td>
                    {/* <td style={{ paddingTop: '0px' }}>{a.observaciones}</td> */}
                    {/* <td
                        style={{ paddingTop: "0px" }}
                        title={a.observaciones} // Tooltip con el texto completo
                      >
                        {a.observaciones && a.observaciones.length > 30
                          ? a.observaciones.substring(0, 20) + "..."
                          : a.observaciones}
                      </td> */}
                    <td style={{ paddingTop: "0px" }}>{a.transportistas}</td>
                    <td style={{ paddingTop: "0px" }}>
                      {a.fechaEntregaCliente}
                    </td>
                    <td style={{ paddingTop: "0px" }}>{a.retornoVacio}</td>
                    <td style={{ paddingTop: "0px" }}>{a.revalidacion}</td>
                    {/* <td style={{ paddingTop: '0px' }}>{a.clientes}</td> */}
                    {/* Fotos */}
                    <td>
                      <Button
                        size="sm"
                        style={{ color: "yellow" }}
                        onClick={(e) =>
                          jalaArchivos(
                            a._id,
                            a.packing,
                            a.bl,
                            a.invoice,
                            a.fichaTecnicaArchivo,
                            a.cargosLocales,
                            a.DODA,
                            a.boleta,
                            a.prealta,
                            a.EIR,
                            a.validacion,
                            a.garantia,
                            a.transporte,
                            a.archivoAtraco,
                            a.archivoCartaEncomienda,
                            a.archivoOtrosDocumentos,
                            a.archivoArchivoPendientes,
                            a.archivoBLRevalidado,
                            a.archivoClasificado,
                            a.archivoCarta318,
                            a.archivoProformaPedimento,
                          )
                        }
                      >
                        <i class="far fa-folder"></i>
                      </Button>
                    </td>

                    <td style={{ paddingTop: "0px" }}>
                      <Button
  size="sm"
  className="btn btn-secondary"
  onClick={() => openPedimentosModal(a)}
  title="Pedimentos"
>
  <i className="far fa-file-alt" />
</Button>
                      <Button
                        size="sm"
                        className="btn"
                        color="danger"
                        onClick={(e) =>
                          PDFOC(
                            a.fecha,
                            a.idNavieras,
                            a.navieras,
                            a.clientes,
                            a.agentes,
                            a.totalCantidad,
                            a.totalGeneral,
                            a.observaciones,
                            a.numero,
                            a._id,
                          )
                        }
                      >
                        <i class="far fa-file-pdf"></i>
                      </Button>
                      {/* {a.rastreo == 'No' && a.idNavieras != "65a093c4b196000019bbeca4" ? (
                      <Button
                      size='sm'
                        color='success'
                        onClick={(e) =>{
                          registrarSG(a._id, a.navieras, a.contenedor)
                        }
                        }
                      >
                        SG
                      </Button>
                      ):(
                        <Button
                          size='sm'
                        color='success'
                          disabled
                          >
                            SG
                          </Button>)}
                      {a.mapa !== 'No' ? (
                      <Button
                      size='sm'
                        onClick={(e) =>{
                          crearMapa(a.polLatitude,
                            a.polLongitude,
                            a.podLatitude,
                            a.podLongitude,
                            a.vesselLatitude,
                            a.vesselLongitude,
                            a.etaReal
                          )
                        }
                        }
                      >
                        <i class='fas fa-map'></i>
                      </Button>
                      ):(
                        <Button
                          size='sm'
                          disabled
                          >
                            <i class='fas fa-map'></i>
                          </Button>)} */}
                      <Button
                        color="info"
                        id="Editar"
                        size="sm"
                        onClick={(e) =>
                          jalaInfo(
                            a.fecha,
                            a.idNavieras,
                            a.idClientes,
                            a.idAgentes,
                            a.idAgencias,
                            a.idComisionistas,
                            a.idTransportistas,
                            a.idForwarders,
                            a.totalCantidad,
                            a.totalGeneral,
                            a.observaciones,
                            a.observacionesInternas,
                            a.numero,
                            a.numeroInterno,
                            a.contenedor,
                            // a.etaEstimada,
                            a.etaReal,
                            a.puerto,
                            a.puertoOrigen,
                            a.numeroBl,
                            a.fechaCita,
                            a.idTerminales,
                            a.pedimento,
                            a.modalidad,
                            a.asegurado,
                            a.direccionEntrega,
                            a.idProgramas,
                            a.idPatentes,
                            a.rastreo,
                            a.pesoTotal,
                            a.recinto,
                            a.totalCargos,
                            a.totalGastos,
                            a.diasLibresDemoras,
                            a.diasLibresAlmacenajes,
                            a.tamanoContenedor,
                            a.pesoContenedor,
                            a.buque,
                            a.regimen,
                            a.claveRegimen,
                            a.selloContenedor,
                            a.referenciaPatente,
                            a.ejecutivo,
                            a._id,
                          )
                        }
                      >
                        <i class="far fa-edit"></i>
                      </Button>
                      <Button
                        color="info"
                        id="Editar"
                        size="sm"
                        onClick={(e) => EditArticulos(a._id, a.numero)}
                      >
                        <i class="fas fa-cart-plus"></i>
                      </Button>

                      <Button
                        color="success"
                        id="Editar"
                        size="sm"
                        onClick={(e) =>
                          EditStatus(
                            a._id,
                            a.bl,
                            a.pl,
                            a.factura,
                            a.numeroInterno,
                            a.documentos,
                            a.telex,
                            a.toquePiso,
                            a.libreAlmacenajes,
                            a.revalidacion,
                            a.fichaTecnica,
                            a.pagoPedimento,
                            a.modulacion,
                            a.retornoVacio,
                            a.salidaPuerto,
                            a.salidaRuta,
                            // a.maniobras,
                            a.entregaCliente,
                            a.status,
                            a.fechaEntradaPuerto,
                            a.fechaDocumentos,
                            a.fechaTelex,
                            a.fechaToquePiso,
                            a.fechaLibreAlmacenajes,
                            a.fechaRevalidacion,
                            a.fechaFichaTecnica,
                            a.fechaPagoPedimento,
                            a.fechaModulacion,
                            a.fechaRetornoVacio,
                            a.fechaSalidaPuerto,
                            a.fechaSalidaRuta,
                            // a.fechaManiobras,
                            a.fechaEntregaCliente,
                            a.fechaFactura,
                            a.fechaBl,
                            a.fechaPl,

                            a.fechaAtraco,
                            a.fechaCartaEncomienda,
                            a.fechaOtrosDocumentos,
                            a.fechaArchivoPendientes,
                            a.fechaBLRevalidado,
                            a.fechaClasificado,
                            a.fechaCarta318,
                            a.fechaProformaPedimento,
                            a.archivoAtraco,
                            a.archivoCartaEncomienda,
                            a.archivoOtrosDocumentos,
                            a.archivoArchivoPendientes,
                            a.archivoBLRevalidado,
                            a.archivoClasificado,
                            a.archivoCarta318,
                            a.archivoProformaPedimento,
                          )
                        }
                      >
                        <i class="fas fa-calendar-check"></i>
                      </Button>
                      {user.contenedoresEntrega ? (
                        <Baja
                          idStatus={a._id}
                          is_active={a.activo}
                          URL_BAJA={process.env.REACT_APP_URL_CONTENEDORES}
                        />
                      ) : undefined}
                      {/* <Button
                        color="primary"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setSelectedContenedor(a._id);
                          setSelectedClienteGasto(a.idClientes);
                          setnumeroInterno(a.numeroInterno);
                          toggleGastos();
                        }}
                      >
                        <i class="fas fa-dollar-sign"></i>
                      </Button>
                      <Button
                        color="info"
                        id="Editar"
                        size="sm"
                        onClick={(e) => {
                          setSelectedContenedor(a._id);
                          setSelectedClienteGasto(a.idClientes);
                          setnumeroInterno(a.numeroInterno);
                          toggleCargos();
                        }}
                      >
                        <i class="fas fa-plus"></i>
                      </Button> */}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          </div>
          <div className='col-md-6'>
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size='xxl' isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            {t('Editar')} {t('Contenedor')} {numeroContenedor}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label>{t('Contenedor')}</Label>
              <Input
                type='text'
                placeholder='Contenedor'
                value={contenedor}
                required
                onChange={(e) => {
                  setContenedor(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t('Numero Bl')}</Label>
              <Input
                type='text'
                placeholder='NumeroBl'
                value={numeroBl}
                required
                onChange={(e) => {
                  setNumeroBl(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t('Fecha Cita')}</Label>
              <Input
                type='date'
                placeholder='fechaCita'
                value={fechaCita}
                onChange={(e) => {
                  setFechaCita(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <Label>{t('Fecha')}</Label>
              <Input
                type='date'
                placeholder='Fecha'
                value={fecha}
                required
                disabled
              />
            </Col>

            <Col md={3}>
              <Label>{t('Numero Interno')}</Label>
              <Input
                type='text'
                placeholder='numeroInterno'
                value={numeroInterno}
                required
                disabled
              />
            </Col>
{totalCargos > 0 || totalGastos > 0 ?(
  <>
  <Col md={3}>
              <Label className='mr-sm-2'>{t('Cliente')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedClienteEdit}
                required
                disabled
              >
                <option value='0'>{t('Selecciona')}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
  </>
) : (
  <>
<Col md={3}>
              <Label className='mr-sm-2'>{t('Cliente')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedClienteEdit}
                required
                onChange={(e) => {
                  setSelectedClienteEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            </>
)}
            
            <Col md={3}>
              <Label className='mr-sm-2'>{t('Naviera')}</Label>
             {rastreo == "No" ?(
               <Input
               className='col-sm-12'
               type='select'
               value={selectedNavieraEdit}
               required
               onChange={(e) => {
                 setSelectedNavieraEdit(e.target.value);
               }}
             >
               <option value='0'>{t('Selecciona')}</option>
               {proveedores
                 .sort((a, b) => (a.name > b.name ? 1 : -1))
                 .map((a) => {
                   if (a.tipo === 'Naviera') {
                     return <option value={a._id}>{a.name}</option>;
                   }
                 })}
             </Input>
             ):( 
             <Input
              className='col-sm-12'
              type='select'
              value={selectedNavieraEdit}
              required
              disabled
            >
              <option value='0'>{t('Selecciona')}</option>
              {proveedores
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => {
                  if (a.tipo === 'Naviera') {
                    return <option value={a._id}>{a.name}</option>;
                  }
                })}
            </Input>)}
            </Col>
          </Row>
          
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>{t('Agente Aduanal')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedAgenteEdit}
                required
                onChange={(e) => {
                  setSelectedAgenteEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.tipo === 'Agente') {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>

            <Col md={3}>
              <Label className='mr-sm-2'>{t('Forwarder')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedForwarderEdit}
                required
                onChange={(e) => {
                  setSelectedForwarderEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.tipo === 'Forwarder') {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label>{t('PuertoOrigen')}</Label>
              <Input
                type='text'
                placeholder='PuertoOrigen'
                value={puertoOrigen}
                required
                onChange={(e) => {
                  setPuertoOrigen(e.target.value);
                }}
              />
            </Col>

            <Col md={3}>
              <Label>{t('Puerto')}</Label>
              <Input
                type='select'
                placeholder='Puerto'
                value={puerto}
                required
                onChange={(e) => {
                  setPuerto(e.target.value);
                }}
              >
                <option value=''>Selecciona</option>
                <option value='Aeropuero CDMX'>Aeropuero CDMX</option>
                <option value='Laredo'>Laredo</option>
                <option value='Lazaro Cardenas'>Lazaro Cardenas</option>
                <option value='Manzanillo'>Manzanillo</option>
                <option value='Progreso'>Progreso</option>
                <option value='Tijuana'>Tijuana</option>
                <option value='Veracruz'>Veracruz</option>
                  <option value="Long Beach">Long Beach</option>
              </Input>
            </Col>

            </Row>
          
          <Row>
            <Col md={3}>
              <Label>{t('Terminal')}</Label>
              <Input
                type='select'
                placeholder='Terminal'
                value={selectedTerminal}
                required
                onChange={(e) => {
                  setSelectedTerminal(e.target.value);
                }}
              >
                {terminales
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            {/* <Col md={3}>
              <Label>{t('Pedimento')}</Label>
              <Input
                type='text'
                placeholder='Pedimento'
                value={pedimento}
                required
                onChange={(e) => {
                  setPedimento(e.target.value);
                }}
              />
            </Col> */}
            <Col md={3}>
              <Label>{t('Programa')}</Label>
              <Input
                type='select'
                placeholder='Programa'
                value={selectedPrograma}
                required
                onChange={(e) => {
                  setSelectedPrograma(e.target.value);
                }}
              >
                {programas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label>{t('Patente')}</Label>
              <Input
                type='select'
                placeholder='Patente'
                value={selectedPatente}
                required
                onChange={(e) => {
                  setSelectedPatente(e.target.value);
                }}
              >
                {patentes
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
          </Row>
          
          <Row>
            <Col md={3}>
              <Label>{t('Modalidad')}</Label>
              <Input
                type='select'
                placeholder='Modalidad'
                value={modalidad}
                required
                onChange={(e) => {
                  setModalidad(e.target.value);
                }}
              >
                <option value=''>Selecciona</option>
                <option value='Tren'>Tren</option>
                <option value='Camion'>Camion</option>
              </Input>
            </Col>
            {/* <Col md={3}>
              <Label>
                {t("Fecha")} ETA {t("Estimada")}
              </Label>
              <Input
                type="date"
                value={fechaETAEstimada}
                required
                onChange={(e) => {
                  setFechaETAEstimada(e.target.value);
                }}
              />
            </Col> */}
            <Col md={3}>
              <Label>{t('Asegurado')}</Label>
              <Input
                type='select'
                placeholder='Asegurado'
                value={asegurado}
                required
                onChange={(e) => {
                  setAsegurado(e.target.value);
                }}
              >
                <option value=''>Selecciona</option>
                <option value='No'>No</option>
                <option value='Si'>Si</option>
                <option value='No Aplica'>No Aplica</option>
              </Input>
            </Col>
            <Col md={3}>
              <Label>{t('Fecha')} ETA</Label>
              <Input
                type='date'
                value={fechaETAReal}
                required
                onChange={(e) => {
                  setFechaETAReal(e.target.value);
                }}
              />
            </Col>
            <Col md={3}>
              <Label>{t('Peso Total')}</Label>
              <Input
                type='number'
                value={pesoTotal}
                required
                onChange={(e) => {
                  setPesoTotal(e.target.value);
                }}
              />
            </Col>
          </Row>
          
          <Row>
          <Col md={3}>
              <Label className='mr-sm-2'>{t('Agencia')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedAgenciaEdit}
                required
                onChange={(e) => {
                  setSelectedAgenciaEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.tipo === 'Agencia') {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label className='mr-sm-2'>{t('Comisionista')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedComisionistaEdit}
                required
                onChange={(e) => {
                  setSelectedComisionistaEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.tipo === 'Comisionista') {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
          <Col md={3}>
              <Label className='mr-sm-2'>{t('Transportista')}</Label>
              <Input
                className='col-sm-12'
                type='select'
                value={selectedTransportistaEdit}
                required
                onChange={(e) => {
                  setSelectedTransportistaEdit(e.target.value);
                }}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    if (a.tipo === 'Transportista') {
                      return <option value={a._id}>{a.name}</option>;
                    }
                  })}
              </Input>
            </Col>
            <Col md={3}>
              <Label>{t('Recinto')}</Label>
              <Input
                type='text'
                value={recinto}
                required
                onChange={(e) => {
                  setRecinto(e.target.value);
                }}
              />
            </Col>
          </Row>
          
          <Row>
            <Col md={6}>
              <Label>{t('Direccion de Entrega')}</Label>
              <Input
                type='text'
                placeholder='Direccion Entrega'
                value={direccionEntrega}
                required
                onChange={(e) => {
                  setDireccionEntrega(e.target.value);
                }}
              />
            </Col>
            </Row>

<Row>
                <Col md={3}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Dias Libres Demoras")}
                  </Label>
                  <Input
                    type="number"
                    placeholder="DiasLibresDemoras"
                    value={diasLibresDemoras}
                    required
                    onChange={(e) => {
                      setDiasLibresDemoras(e.target.value);
                    }}
                  />
                </Col>
                <Col md={3}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Dias Libres Almacenajes")}
                  </Label>
                  <Input
                    type="number"
                    placeholder="DiasLibresAlmacenajes"
                    value={diasLibresAlmacenajes}
                    required
                    onChange={(e) => {
                      setDiasLibresAlmacenajes(e.target.value);
                    }}
                  />
                </Col>
                 <Col md={3}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Tamaño Contenedor")}
                  </Label>
                  <Input
                    type="text"
                    placeholder="TamanoContenedor"
                    value={tamanoContenedor}
                    required
                    onChange={(e) => {
                      setTamanoContenedor(e.target.value);
                    }}
                  />
                </Col>
                </Row>
                <Row>
  <Col md={3}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Peso Contenedor")}
                  </Label>
                  <Input
                    type="text"
                    placeholder="PesoContenedor"
                    value={pesoContenedor}
                    required
                    onChange={(e) => {
                      setPesoContenedor(e.target.value);
                    }}
                  />
                </Col>
  
                <Col md={3}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Buque")}
                  </Label>
                  <Input
                    type="text"
                    placeholder="Buque"
                    value={buque}
                    required
                    onChange={(e) => {
                      setBuque(e.target.value);
                    }}
                  />
                </Col>
  
   <Col md={3}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Regimen")}
                  </Label>
                  <Input
                    type="text"
                    placeholder="Regimen"
                    value={regimen}
                    required
                    onChange={(e) => {
                      setRegimen(e.target.value);
                    }}
                  />
                </Col>
                 <Col md={3}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Clave Regimen")}
                  </Label>
                  <Input
                    type="text"
                    placeholder="ClaveRegimen"
                    value={claveRegimen}
                    required
                    onChange={(e) => {
                      setClaveRegimen(e.target.value);
                    }}
                  />
                </Col>
                </Row>
                <Row>
                   <Col md={3}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Recinto")}
                  </Label>
                  <Input
                    type="text"
                    placeholder="Recinto"
                    value={recinto}
                    required
                    onChange={(e) => {
                      setRecinto(e.target.value);
                    }}
                  />
                </Col>
  
                 <Col md={3}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Sello Contenedor")}
                  </Label>
                  <Input
                    type="text"
                    placeholder="SelloContenedor"
                    value={selloContenedor}
                    required
                    onChange={(e) => {
                      setSelloContenedor(e.target.value);
                    }}
                  />
                </Col>
  
                <Col md={3}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Referencia Patente")}
                  </Label>
                  <Input
                    type="text"
                    placeholder="ReferenciaPatente"
                    value={referenciaPatente}
                    required
                    onChange={(e) => {
                      setReferenciaPatente(e.target.value);
                    }}
                  />
                </Col>
                <Col md={3}>
                  <Label for="exampleEmail" className="mr-sm-2">
                    {t("Ejecutivo")}
                  </Label>
                  <Input
                    type="text"
                    placeholder="Ejecutivo"
                    value={ejecutivo}
                    required
                    onChange={(e) => {
                      setEjecutivo(e.target.value);
                    }}
                  />
                </Col>
  
  
                </Row>

          <Row>
            <Col md={6}>
              <Label for='exampleEmail' className='mr-sm-2'>
                {t('Observaciones')}
              </Label>
              <Input
                type='textarea'
                placeholder='Observaciones'
                value={observaciones}
                required
                onChange={(e) => {
                  setObservaciones(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label for='exampleEmail' className='mr-sm-2'>
                {t('Observaciones Internas')}
              </Label>
              <Input
                type='textarea'
                placeholder='ObservacionesInternas'
                value={observacionesInternas}
                required
                onChange={(e) => {
                  setObservacionesInternas(e.target.value);
                }}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color='success' onClick={editContenedores}>
            {t('Guardar')}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        size='xxl'
        isOpen={modalEditArticulos}
        toggle={toggleEditArticulos}
      >
        <ModalHeader toggle={toggleEditArticulos}>
          <h4>
            {'Editar'} {t('Articulos')} {t('Contenedor')} {numeroContenedor}
          </h4>
          <h4>
            TOTAL {totalCantidad_edit} pzas. /{' '}
            {new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 2,
            }).format(totalGeneral_edit)}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Articulos')}</Label>
            </Col>
            <Col md={2}>
              <Label className='mr-sm-2'>{t('Descripcion')}</Label>
            </Col>
            <Col md={1}>
              <Label className='mr-sm-2'>{t('Cantidad')}</Label>
            </Col>
            <Col md={1}>
              <Label className='mr-sm-2'>{t('Precio')}</Label>
            </Col>
            <Col md={2}>
              <Label className='mr-sm-2'>Total</Label>
            </Col>
          </Row>

          {articulosContenedor.map((ao) => (
            <div key={ao.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='articulos'
                    type='select'
                    value={ao.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticuloExistentes(ao.id, event);
                    }}
                  >
                    <option value='0'>{t('Selecciona')}</option>
                    {articulos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='descripcion'
                    type='text'
                    placeholder='descripcion'
                    value={ao.descripcion}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name='cantidad'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Cantidad'
                    value={ao.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentesCantidad(ao.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name='precio'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Precio'
                    value={ao.precio}
                    required
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='total'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Total'
                    value={ao.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInputExistentes(ao.id, event)
                    }
                  />
                </Col>
              </Row>
            </div>
          ))}

          {/* Agregar mas articulos */}

          {inputFields.map((inputField) => (
            <div key={inputField.id}>
              <Row>
                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='articulos'
                    type='select'
                    value={inputField.articulos}
                    required
                    onChange={(event) => {
                      BuscaArticulo(inputField.id, event);
                    }}
                  >
                    <option value='0'>{t('Selecciona')}</option>
                    {articulos
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => {
                        return <option value={a._id}>{a.name}</option>;
                      })}
                  </Input>
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='descripcion'
                    type='text'
                    placeholder='descripcion'
                    value={inputField.descripcion}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name='cantidad'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Cantidad'
                    value={inputField.cantidad}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={1}>
                  <Input
                    // bsSize="sm"
                    name='precio'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Precio'
                    value={inputField.precio}
                    required
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>

                <Col md={2}>
                  <Input
                    // bsSize="sm"
                    name='total'
                    type='number'
                    min='0'
                    step='any'
                    placeholder='Total'
                    value={inputField.total}
                    disabled
                    onChange={(event) =>
                      handleChangeInput(inputField.id, event)
                    }
                  />
                </Col>
                <Col>
                  <Button
                    size='sm'
                    className='btn'
                    color='danger'
                    disabled={inputFields.length === 1}
                    onClick={() => handleRemoveFields(inputField.id)}
                    tabindex='-1'
                  >
                    <i class='fas fa-minus'></i>
                  </Button>
                  <Button
                    size='sm'
                    className='btn'
                    color='info'
                    onClick={handleAddFields}
                    tabindex='-1'
                  >
                    <i class='fas fa-plus'></i>
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
          <Row>
            <Col md={6}>
              <h4 id='logoutBoton'>
                TOTAL {totalCantidad_edit} pzas. /{' '}
                {new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  maximumFractionDigits: 2,
                }).format(totalGeneral_edit)}
              </h4>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button size='sm' color='success' onClick={saveContenedor}>
            {t('Guardar')}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size='sm' isOpen={modalProgreso} toggle={toggleProgreso}>
        <ModalHeader toggle={toggleProgreso}>
          <h4>{t('Progreso')}</h4>
        </ModalHeader>
        <ModalBody>
          <h4>
            {' '}
            {t('Este proceso puede tardar varios segundos.')}
            <br />
            {t('Por favor no cierre ni refresque su navegador.')}
          </h4>
          <br />
          <div className='progreso'>
            <Spinner
              style={{
                width: '50px',
                height: '50px',
                color: '#232B41',
              }}
            />
            <Spinner
              style={{
                width: '50px',
                height: '50px',
                color: '#232B41',
              }}
            />
            <Spinner
              style={{
                width: '50px',
                height: '50px',
                color: '#232B41',
              }}
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal size='lg' isOpen={modalStatus} toggle={toggleStatus}>
        <ModalHeader toggle={toggleStatus}>
          <h4>
            {t('Status')} Contenedor {numeroInterno}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Button size='sm' className='btn' color='primary' onClick={excelOC}>
              Excel <i class='far fa-file-excel'></i>
            </Button>
          </Row>
          <Row>
            <Col md={4}>
              <Label>Status</Label>
              <Input
                type='select'
                value={status}
                onChange={(e) => setstatus(e.target.value)}
              >
                 <option value=''>Selecciona</option>
                  <option value='En Transito'>En Transito</option>
                  <option value='Arribo'>Arribo</option>
                  <option value='En Piso'>En Piso</option>
                  <option value='Cita Obtenida'>Cita Obtenida</option>
                  <option value='Desaduanado'>Desaduanado</option>
                  <option value='Maniobras de Vacio'>Maniobras de Vacio</option>
                  <option value='Entrega Cliente Final'>Entrega Cliente Final</option>
                  <option value='Falta EIR'>Falta EIR</option>
                  <option value='Finalizado'>Finalizado</option>
                  <option value='Pendiente'>Pendiente</option>
                  <option value='Cancelado'>Cancelado</option>
                  <option value='Cancelado Con Pend'>Cancelado Con Pend</option>
                  <option value='Retenido Por Aduana'>Retenido Por Aduana</option>
                  <option value='Abandono'>Abandono</option>
              </Input>
              {/* </Col>
                <Col md={3}>
                  <Label>.</Label> */}
              <Button onClick={() => updateOnlyStatus()} size='sm'>
                Actualizar
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Concepto</Label>
            </Col>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Fecha</Label>
            </Col>
            <Col md={3} className='negrita'>
              <Label className='mr-sm-2'>Realizado</Label>
            </Col>
          </Row>

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>BL</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaBl}
                onChange={(e) => setfechaBl(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{bl === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={bl === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'bl',
                    bl === 'Si' ? 'No' : 'Si',
                    'fechaBl',
                    fechaBl
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
           <Row>
            
            <Col md={3}>
              <Label className='mr-sm-2'>Atraco</Label>
            </Col>
            {datoArchivoAtraco === "Si" ? (
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaAtraco}
                onChange={(e) => setFechaAtraco(e.target.value)}
              />
            </Col>
            ) : (
<Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaAtraco}
                disabled
              />
            </Col>
            )}

            <Col md={3}>
              <Label>{atraco === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

{datoArchivoAtraco === "Si" ? (
            <Col md={3}>
              <Button
                color={atraco === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'atraco',
                    atraco === 'Si' ? 'No' : 'Si',
                    'fechaAtraco',
                    fechaAtraco
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            ) : (
              <Col md={3}>
              <Button
                color={atraco === 'Si' ? 'primary' : 'danger'}
                disabled
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            )}
          </Row>
          <br />

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Carta Encomienda</Label>
            </Col>
            {datoArchivoCartaEncomienda === "Si" ? (
              <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaCartaEncomienda}
                onChange={(e) => setFechaCartaEncomienda(e.target.value)}
              />
            </Col>
            ) : (
              <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaCartaEncomienda}
                disabled
              />
            </Col>
            )}

            <Col md={3}>
              <Label>{cartaEncomienda === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

{datoArchivoCartaEncomienda === "Si" ? (
            <Col md={3}>
              <Button
                color={cartaEncomienda === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'cartaEncomienda',
                    cartaEncomienda === 'Si' ? 'No' : 'Si',
                    'fechaCartaEncomienda',
                    fechaCartaEncomienda
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            ) : (
              <Col md={3}>
              <Button
                color={cartaEncomienda === 'Si' ? 'primary' : 'danger'}
                disabled
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            )}
          </Row>
          <br />

           <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Otros Documentos</Label>
            </Col>
            {datoArchivoOtrosDocumentos === "Si" ? (
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaOtrosDocumentos}
                onChange={(e) => setFechaOtrosDocumentos(e.target.value)}
              />
            </Col>
            ) : (
              <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaOtrosDocumentos}
                disabled
              />
            </Col>
            )}

            <Col md={3}>
              <Label>{otrosDocumentos === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

{datoArchivoOtrosDocumentos === "Si" ? (
            <Col md={3}>
              <Button
                color={otrosDocumentos === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'otrosDocumentos',
                    otrosDocumentos === 'Si' ? 'No' : 'Si',
                    'fechaOtrosDocumentos',
                    fechaOtrosDocumentos
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            ) : (
              <Col md={3}>
              <Button
                color={otrosDocumentos === 'Si' ? 'primary' : 'danger'}
                disabled
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            )}
          </Row>
          <br />

 <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Archivo Pendientes</Label>
            </Col>
            {datoArchivoArchivoPendientes === "Si" ? (
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaArchivoPendientes}
                onChange={(e) => setFechaArchivoPendientes(e.target.value)}
              />
            </Col>
            ) : (
              <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaArchivoPendientes}
                disabled
              />
            </Col>
            )}

            <Col md={3}>
              <Label>{archivoPendientes === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            {datoArchivoArchivoPendientes === "Si" ? (
            <Col md={3}>
              <Button
                color={archivoPendientes === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'archivoPendientes',
                    archivoPendientes === 'Si' ? 'No' : 'Si',
                    'fechaArchivoPendientes',
                    fechaArchivoPendientes
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            ) : (
<Col md={3}>
              <Button
                color={archivoPendientes === 'Si' ? 'primary' : 'danger'}
                disabled
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            )}
          </Row>
          <br />

 <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>BL Revalidado</Label>
            </Col>
            {datoArchivoBLRevalidado === "Si" ? (
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaBlRevalidado}
                onChange={(e) => setFechaBlRevalidado(e.target.value)}
              />
            </Col>
            ) : (
              <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaBlRevalidado}
                disabled
              />
            </Col>
            )}

            <Col md={3}>
              <Label>{blRevalidado === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>
{datoArchivoBLRevalidado === "Si" ? (
            <Col md={3}>
              <Button
                color={blRevalidado === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'blRevalidado',
                    blRevalidado === 'Si' ? 'No' : 'Si',
                    'fechaBlRevalidado',
                    fechaBlRevalidado
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            ) : (
              <Col md={3}>
              <Button
                color={blRevalidado === 'Si' ? 'primary' : 'danger'}
                disabled
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            )}
          </Row>
          <br />

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Clasificado</Label>
            </Col>
            {datoArchivoClasificado === "Si" ? (
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaClasificado}
                onChange={(e) => setFechaClasificado(e.target.value)}
              />
            </Col>
            ) : (
              <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaClasificado}
                disabled
              />
            </Col>
            )}


            <Col md={3}>
              <Label>{clasificado === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>
{datoArchivoClasificado === "Si" ? (
            <Col md={3}>
              <Button
                color={clasificado === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'clasificado',
                    clasificado === 'Si' ? 'No' : 'Si',
                    'fechaClasificado',
                    fechaClasificado
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            ) : (
              <Col md={3}>
              <Button
                color={clasificado === 'Si' ? 'primary' : 'danger'}
                disabled
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            )}
          </Row>
          <br />

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Carta 3.1.8</Label>
            </Col>
            {datoArchivoCarta318 === "Si" ? (
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaCarta318}
                onChange={(e) => setFechaCarta318(e.target.value)}
              />
            </Col>
            ) : (
              <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaCarta318}
                disabled
              />
            </Col>
            )}

            <Col md={3}>
              <Label>{carta318 === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>
{datoArchivoCarta318 === "Si" ? (
            <Col md={3}>
              <Button
                color={carta318 === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'carta318',
                    carta318 === 'Si' ? 'No' : 'Si',
                    'fechaCarta318',
                    fechaCarta318
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            ) : (
              <Col md={3}>
              <Button
                color={carta318 === 'Si' ? 'primary' : 'danger'}
                disabled
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            )}
          </Row>
          <br />

<Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Proforma Pedimento</Label>
            </Col>
            {datoArchivoProformaPedimento === "Si" ? (
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaProformaPedimento}
                onChange={(e) => setFechaProformaPedimento(e.target.value)}
              />
            </Col>
            ) : (
              <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaProformaPedimento}
                disabled
              />
            </Col>
            )}

            <Col md={3}>
              <Label>{proformaPedimento === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>
{datoArchivoProformaPedimento === "Si" ? (
            <Col md={3}>
              <Button
                color={proformaPedimento === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'proformaPedimento',
                    proformaPedimento === 'Si' ? 'No' : 'Si',
                    'fechaProformaPedimento',
                    fechaProformaPedimento
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            ) : (
               <Col md={3}>
              <Button
                color={proformaPedimento === 'Si' ? 'primary' : 'danger'}
                disabled
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
            )}
          </Row>
          <br />




          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Packing List</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaPl}
                onChange={(e) => setfechaPl(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{pl === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={pl === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'pl',
                    pl === 'Si' ? 'No' : 'Si',
                    'fechaPl',
                    fechaPl
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Factura</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaFactura}
                onChange={(e) => setfechaFactura(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{factura === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={factura === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'factura',
                    factura === 'Si' ? 'No' : 'Si',
                    'fechaFactura',
                    fechaFactura
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>FichaTecnica</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaFichaTecnica}
                onChange={(e) => setfechaFichaTecnica(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{fichaTecnica === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={fichaTecnica === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'fichaTecnica',
                    fichaTecnica === 'Si' ? 'No' : 'Si',
                    'fechaFichaTecnica',
                    fechaFichaTecnica
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Telex</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaTelex}
                onChange={(e) => setfechaTelex(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{telex === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={telex === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'telex',
                    telex === 'Si' ? 'No' : 'Si',
                    'fechaTelex',
                    fechaTelex
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Toque de Piso</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaToquePiso}
                onChange={(e) => setfechaToquePiso(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{toquePiso === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={toquePiso === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'toquePiso',
                    toquePiso === 'Si' ? 'No' : 'Si',
                    'fechaToquePiso',
                    fechaToquePiso
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Libre Almacenajes</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaLibreAlmacenajes}
                onChange={(e) => setfechaLibreAlmacenajes(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{libreAlmacenajes === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={libreAlmacenajes === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'libreAlmacenajes',
                    libreAlmacenajes === 'Si' ? 'No' : 'Si',
                    'fechaLibreAlmacenajes',
                    fechaLibreAlmacenajes
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Revalidacion</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaRevalidacion}
                onChange={(e) => setfechaRevalidacion(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{revalidacion === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={revalidacion === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'revalidacion',
                    revalidacion === 'Si' ? 'No' : 'Si',
                    'fechaRevalidacion',
                    fechaRevalidacion
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Pedimento Pagado</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaPagoPedimento}
                onChange={(e) => setfechaPagoPedimento(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{pagoPedimento === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={pagoPedimento === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'pagoPedimento',
                    pagoPedimento === 'Si' ? 'No' : 'Si',
                    'fechaPagoPedimento',
                    fechaPagoPedimento
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          {/* <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Documentos</Label>
            </Col>
            <Col md={3} className="negro">
              <Input
                type="date"
                value={fechaDocumentos}
                onChange={(e) => setfechaDocumentos(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{documentos === "Si" ? "Listo" : "Pendiente"}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={documentos === "Si" ? "primary" : "danger"}
                onClick={() =>
                  updateStatus(
                    "documentos",
                    documentos === "Si" ? "No" : "Si",
                    "fechaDocumentos",
                    fechaDocumentos
                  )
                }
                size="sm"
              >
                <i className="fas fa-check-circle"></i>
              </Button>
            </Col>
          </Row>
          <br /> */}
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Modulacion</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaModulacion}
                onChange={(e) => setfechaModulacion(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{modulacion === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={modulacion === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'modulacion',
                    modulacion === 'Si' ? 'No' : 'Si',
                    'fechaModulacion',
                    fechaModulacion
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />

          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Salida de Despacho</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaSalidaPuerto}
                onChange={(e) => setfechaSalidaPuerto(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{salidaPuerto === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={salidaPuerto === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'salidaPuerto',
                    salidaPuerto === 'Si' ? 'No' : 'Si',
                    'fechaSalidaPuerto',
                    fechaSalidaPuerto
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Salida Ruta</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaSalidaRuta}
                onChange={(e) => setfechaSalidaRuta(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{salidaRuta === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={salidaRuta === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'salidaRuta',
                    salidaRuta === 'Si' ? 'No' : 'Si',
                    'fechaSalidaRuta',
                    fechaSalidaRuta
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />

          {/* <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Maniobras</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaManiobras}
                onChange={(e) => setfechaManiobras(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{maniobras === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={maniobras === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'maniobras',
                    maniobras === 'Si' ? 'No' : 'Si',
                    'fechaManiobras',
                    fechaManiobras
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row> 
          <br />*/}

          {user.contenedoresEntrega?(
            <>
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Entrega Cliente</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaEntregaCliente}
                onChange={(e) => setfechaEntregaCliente(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{entregaCliente === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={entregaCliente === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'entregaCliente',
                    entregaCliente === 'Si' ? 'No' : 'Si',
                    'fechaEntregaCliente',
                    fechaEntregaCliente
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
          </>
        ):undefined}
          <Row>
            <Col md={3}>
              <Label className='mr-sm-2'>Retorno Vacio</Label>
            </Col>
            <Col md={3} className='negro'>
              <Input
                type='date'
                value={fechaRetornoVacio}
                onChange={(e) => setfechaRetornoVacio(e.target.value)}
              />
            </Col>

            <Col md={3}>
              <Label>{retornoVacio === 'Si' ? 'Listo' : 'Pendiente'}</Label>
            </Col>

            <Col md={3}>
              <Button
                color={retornoVacio === 'Si' ? 'primary' : 'danger'}
                onClick={() =>
                  updateStatus(
                    'retornoVacio',
                    retornoVacio === 'Si' ? 'No' : 'Si',
                    'fechaRetornoVacio',
                    fechaRetornoVacio
                  )
                }
                size='sm'
              >
                <i className='fas fa-check-circle'></i>
              </Button>
            </Col>
          </Row>
          <br />
        </ModalBody>
      </Modal>

      <Modal size='lg' isOpen={modalGastos} toggle={toggleGastos}>
        <ModalHeader toggle={toggleGastos}>
          <h4>
            {t('Gastos')} Contenedor {numeroInterno}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Fecha')}</Label>
              <Input
                type='date'
                placeholder='Fecha'
                value={fechaGasto}
                required
                onChange={(e) => {
                  setFechaGasto(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>Proveedor</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={selectedProveedor}
                onChange={(e) => setSelectedProveedor(e.target.value)}
              >
                <option value='0'>{t('Selecciona')}</option>
                {proveedores
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={6}>
              <Label className='mr-sm-2'>{t('Cliente')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={selectedClienteGasto}
                disabled
              >
                <option value='0'>{t('Selecciona')}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Concepto')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={selectedConcepto}
                onChange={(e) => setSelectedConcepto(e.target.value)}
              >
                <option value='0'>{t('Selecciona')}</option>
                {conceptosGastos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={6}>
              <Label for='exampleEmail' className='mr-sm-2'>
                {t('Descripcion')}
              </Label>
              <Input
                type='text'
                placeholder='Descripcion'
                value={descripcion}
                required
                onChange={(e) => {
                  setDescripcion(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Moneda')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={moneda}
                onChange={(e) => {
                  setMoneda(e.target.value);
                  setTotalUSD(0);
                  setTotal(0);
                  setTipoCambio(1);
                }}
              >
                <option value='MXN'>{t('MXN')}</option>
                <option value='USD'>{t('USD')}</option>
              </Input>
            </Col>
          </Row>
          {moneda === 'USD' ? (
            <Row>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total USD')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  placeholder='TotalUSD'
                  value={totalUSD}
                  required
                  onChange={(e) => calcula(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  Tipo de Cambio
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  placeholder='TipoCambio'
                  value={tipoCambio}
                  required
                  onChange={(e) => calculaTipoCambio(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total MXN')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  value={total}
                  disabled
                  // onChange={(e) => calculaMXN(e.target.value)}
                />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total MXN')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  value={total}
                  onChange={(e) => {
                    setTotal(e.target.value);
                    setTotalUSD(e.target.value / tipoCambio);
                  }}
                />
              </Col>
            </Row>
          )}
          <br />
          {validaBoton ? (
            <Button color='success' onClick={() => saveGasto()}>
              Guardar
            </Button>
          ) : (
            <Button color='success' disabled>
              Guardar
            </Button>
          )}
        </ModalBody>
      </Modal>

      <Modal size='lg' isOpen={modalCargos} toggle={toggleCargos}>
        <ModalHeader toggle={toggleCargos}>
          <h4>
            {t('Cargos')} Contenedor {numeroInterno}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Fecha')}</Label>
              <Input
                type='date'
                placeholder='Fecha'
                value={fechaGasto}
                required
                onChange={(e) => {
                  setFechaGasto(e.target.value);
                }}
              />
            </Col>

            <Col md={6}>
              <Label className='mr-sm-2'>{t('Cliente')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={selectedClienteGasto}
                disabled
              >
                <option value='0'>{t('Selecciona')}</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Concepto')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={selectedConcepto}
                onChange={(e) => setSelectedConcepto(e.target.value)}
              >
                <option value='0'>{t('Selecciona')}</option>
                {conceptosGastos
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>

            <Col md={6}>
              <Label for='exampleEmail' className='mr-sm-2'>
                {t('Descripcion')}
              </Label>
              <Input
                type='text'
                placeholder='Descripcion'
                value={descripcion}
                required
                onChange={(e) => {
                  setDescripcion(e.target.value);
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label className='mr-sm-2'>{t('Moneda')}</Label>
              <Input
                // bsSize="sm"
                type='select'
                required
                value={moneda}
                onChange={(e) => {
                  setMoneda(e.target.value);
                  setTotalUSD(0);
                  setTotal(0);
                  setTipoCambio(1);
                }}
              >
                <option value='MXN'>{t('MXN')}</option>
                <option value='USD'>{t('USD')}</option>
              </Input>
            </Col>
          </Row>
          {moneda === 'USD' ? (
            <Row>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total USD')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  placeholder='TotalUSD'
                  value={totalUSD}
                  required
                  onChange={(e) => calcula(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  Tipo de Cambio
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  placeholder='TipoCambio'
                  value={tipoCambio}
                  required
                  onChange={(e) => calculaTipoCambio(e.target.value)}
                />
              </Col>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total MXN')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  value={total}
                  disabled
                  // onChange={(e) => calculaMXN(e.target.value)}
                />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col sm={4}>
                <Label for='exampleEmail' className='mr-sm-2'>
                  {t('Total MXN')}
                </Label>
                <Input
                  type='number'
                  min='0'
                  step='any'
                  value={total}
                  onChange={(e) => {
                    setTotal(e.target.value);
                    setTotalUSD(e.target.value / tipoCambio);
                  }}
                />
              </Col>
            </Row>
          )}
          <br />
          {validaBoton ? (
            <Button color='success' onClick={() => saveCargo()}>
              Guardar
            </Button>
          ) : (
            <Button color='success' disabled>
              Guardar
            </Button>
          )}
        </ModalBody>
      </Modal>

      <Modal size='sm' isOpen={modalETA} toggle={toggleETA}>
        <ModalHeader toggle={toggleETA}>
          <h4>{t('Actualizar ETAs')}</h4>
        </ModalHeader>
        <ModalBody>
          <EtaUpdate />
        </ModalBody>
      </Modal>

       <Modal size="sm" isOpen={modalSubirFotoAtraco} toggle={toggleSubirFotoAtraco}>
        <ModalHeader toggle={toggleSubirFotoAtraco}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosAtraco}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoCartaEncomienda} toggle={toggleSubirFotoCartaEncomienda}>
        <ModalHeader toggle={toggleSubirFotoCartaEncomienda}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosCartaEncomienda}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoOtrosDocumentos} toggle={toggleSubirFotoOtrosDocumentos}>
        <ModalHeader toggle={toggleSubirFotoOtrosDocumentos}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosOtrosDocumentos}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoArchivoPendientes} toggle={toggleSubirFotoArchivoPendientes}>
        <ModalHeader toggle={toggleSubirFotoArchivoPendientes}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosArchivoPendientes}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoBLRevalidado} toggle={toggleSubirFotoBLRevalidado}>
        <ModalHeader toggle={toggleSubirFotoBLRevalidado}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosBLRevalidado}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoClasificado} toggle={toggleSubirFotoClasificado}>
        <ModalHeader toggle={toggleSubirFotoClasificado}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosClasificado}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoCarta318} toggle={toggleSubirFotoCarta318}>
        <ModalHeader toggle={toggleSubirFotoCarta318}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosCarta318}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoProformaPedimento} toggle={toggleSubirFotoProformaPedimento}>
        <ModalHeader toggle={toggleSubirFotoProformaPedimento}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosProformaPedimento}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoPacking} toggle={toggleSubirFotoPacking}>
        <ModalHeader toggle={toggleSubirFotoPacking}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosPacking}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoBL} toggle={toggleSubirFotoBL}>
        <ModalHeader toggle={toggleSubirFotoBL}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosBL}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoInvoice} toggle={toggleSubirFotoInvoice}>
        <ModalHeader toggle={toggleSubirFotoInvoice}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosInvoice}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoFichaTecnica} toggle={toggleSubirFotoFichaTecnica}>
        <ModalHeader toggle={toggleSubirFotoFichaTecnica}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosFichaTecnica}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoCargosLocales} toggle={toggleSubirFotoCargosLocales}>
        <ModalHeader toggle={toggleSubirFotoCargosLocales}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosCargosLocales}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoDODA} toggle={toggleSubirFotoDODA}>
        <ModalHeader toggle={toggleSubirFotoDODA}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosDODA}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoBoleta} toggle={toggleSubirFotoBoleta}>
        <ModalHeader toggle={toggleSubirFotoBoleta}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosBoleta}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoPrealta} toggle={toggleSubirFotoPrealta}>
        <ModalHeader toggle={toggleSubirFotoPrealta}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosPrealta}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoEIR} toggle={toggleSubirFotoEIR}>
        <ModalHeader toggle={toggleSubirFotoEIR}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosEIR}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoValidacion} toggle={toggleSubirFotoValidacion}>
        <ModalHeader toggle={toggleSubirFotoValidacion}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosValidacion}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

      <Modal size="sm" isOpen={modalSubirFotoGarantia} toggle={toggleSubirFotoGarantia}>
        <ModalHeader toggle={toggleSubirFotoGarantia}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosGarantia}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalSubirFotoTransporte} toggle={toggleSubirFotoTransporte}>
        <ModalHeader toggle={toggleSubirFotoTransporte}>
          <h4>Subir Fotos</h4>
        </ModalHeader>
        <ModalBody>
        <Row>
                  <Col md={12}>
              <Label>
                Selecciona los Archivos
              </Label>
              <Input
                type="file"
                multiple
                onChange={(e) => {
                  setFile(Array.from(e.target.files));
                  // setFile(e.target.files[0]);
                }}
              />
            </Col>
                  </Row>
          <Button size="sm" color="success" onClick={guardaFotosTransporte}>
            Guardar
          </Button>
        </ModalBody>
      </Modal>

          <Modal size="xxl" isOpen={modalFotoAtraco} toggle={toggleFotoAtraco}>
      <ModalHeader toggle={toggleFotoAtraco}>
        <h4>Atraco</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

              <Modal size="xxl" isOpen={modalFotoCartaEncomienda} toggle={toggleFotoCartaEncomienda}>
      <ModalHeader toggle={toggleFotoCartaEncomienda}>
        <h4>Carta Encomienda</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

              <Modal size="xxl" isOpen={modalFotoOtrosDocumentos} toggle={toggleFotoOtrosDocumentos}>
      <ModalHeader toggle={toggleFotoOtrosDocumentos}>
        <h4>Otros Documentos</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

          <Modal size="xxl" isOpen={modalFotoArchivoPendientes} toggle={toggleFotoArchivoPendientes}>
      <ModalHeader toggle={toggleFotoArchivoPendientes}>
        <h4>Archivo Pendientes</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

              <Modal size="xxl" isOpen={modalFotoBLRevalidado} toggle={toggleFotoBLRevalidado}>
      <ModalHeader toggle={toggleFotoBLRevalidado}>
        <h4>BL Revalidado</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

                  <Modal size="xxl" isOpen={modalFotoClasificado} toggle={toggleFotoClasificado}>
      <ModalHeader toggle={toggleFotoClasificado}>
        <h4>Clasificado</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

                      <Modal size="xxl" isOpen={modalFotoCarta318} toggle={toggleFotoCarta318}>
      <ModalHeader toggle={toggleFotoCarta318}>
        <h4>Carta 3.1.8</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

                      <Modal size="xxl" isOpen={modalFotoProformaPedimento} toggle={toggleFotoProformaPedimento}>
      <ModalHeader toggle={toggleFotoProformaPedimento}>
        <h4>Proforma Pedimento</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>
          
    <Modal size="xxl" isOpen={modalFotoPacking} toggle={toggleFotoPacking}>
      <ModalHeader toggle={toggleFotoPacking}>
        <h4>Packing List</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoBL} toggle={toggleFotoBL}>
      <ModalHeader toggle={toggleFotoBL}>
        <h4>BL</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>
        
    <Modal size="xxl" isOpen={modalFotoInvoice} toggle={toggleFotoInvoice}>
      <ModalHeader toggle={toggleFotoInvoice}>
        <h4>Invoice</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoFichaTecnica} toggle={toggleFotoFichaTecnica}>
      <ModalHeader toggle={toggleFotoFichaTecnica}>
        <h4>Ficha Tecnica</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoCargosLocales} toggle={toggleFotoCargosLocales}>
      <ModalHeader toggle={toggleFotoCargosLocales}>
        <h4>Cargos Locales</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
               ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoDODA} toggle={toggleFotoDODA}>
      <ModalHeader toggle={toggleFotoDODA}>
        <h4>DODA</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoBoleta} toggle={toggleFotoBoleta}>
      <ModalHeader toggle={toggleFotoBoleta}>
        <h4>Boleta</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoPrealta} toggle={toggleFotoPrealta}>
      <ModalHeader toggle={toggleFotoPrealta}>
        <h4>Prealta</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoEIR} toggle={toggleFotoEIR}>
      <ModalHeader toggle={toggleFotoEIR}>
        <h4>EIR</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoValidacion} toggle={toggleFotoValidacion}>
      <ModalHeader toggle={toggleFotoValidacion}>
        <h4>Validacion</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoGarantia} toggle={toggleFotoGarantia}>
      <ModalHeader toggle={toggleFotoGarantia}>
        <h4>Garantia</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>

    <Modal size="xxl" isOpen={modalFotoTransporte} toggle={toggleFotoTransporte}>
      <ModalHeader toggle={toggleFotoTransporte}>
        <h4>Transporte</h4>
      </ModalHeader>
      <ModalBody>
      <Row>
      {photo?.length > 0 ? (
        photo.map((item) => (
          <div key={item.id} style={{ textAlign: "center", marginBottom: "20px" }}>
            {item.format === "pdf" ? (
              <embed
                src={item.secure_url}
                type="application/pdf"
                width="500"
                height="600"
              />
            ) : item.format === "xls" || item.format === "xlsx" || item.format === "xlsm" ? (
              <a href={item.secure_url} download>
                <Button color="primary">
                  Descargar {item.original_filename}. {item.format}
                </Button>
              </a>
              ) : item.format === "doc" || item.format === "docx" ? (
                <a href={item.secure_url} download>
                  <Button color="primary">
                    Descargar {item.original_filename}.{item.format}
                  </Button>
                </a>
            ) : (
              <img
                src={item.secure_url}
                alt="Uploaded Image"
                width="250"
                height="auto"
              />
            )}
            <div>
              <Button
                color="danger"
                onClick={() => borrarFoto(item.asset_id)}
                style={{ marginTop: "10px" }}
              >
                Eliminar
              </Button>
            </div>
          </div>
        ))
      ) : (
        <h4>No se ha subido una Foto, PDF o archivo Excel....</h4>
      )}
    </Row>
      </ModalBody>
    </Modal>



    <Modal size="sm" isOpen={modalFotos} toggle={toggleFotos}>
      <ModalHeader toggle={toggleFotos}>
        <h4>Archivos</h4>
      </ModalHeader>
      <ModalBody>
        <Table>
          <thead>
            <tr>
              <th>Titulo</th>
              <th>Archivos</th>
            </tr>
            </thead>
            <tbody>
                <tr>
                  <td>Atraco</td>
                  <td>
                            <>
                              {archivoAtraco == "Si" ? (
                                <>
                                {/* {Atraco} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoAtraco(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.Atraco} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoAtraco();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>


                <tr>
                  <td>Carta Encomienda</td>
                  <td>
                            <>
                              {archivoCartaEncomienda == "Si" ? (
                                <>
                                {/* {CartaEncomienda} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoCartaEncomienda(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.CartaEncomienda} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoCartaEncomienda();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>


                <tr>
                  <td>Otros Documentos</td>
                  <td>
                            <>
                              {archivoOtrosDocumentos == "Si" ? (
                                <>
                                {/* {OtrosDocumentos} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoOtrosDocumentos(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.OtrosDocumentos} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoOtrosDocumentos();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>

                                <tr>
                  <td>Archivo Pendientes</td>
                  <td>
                            <>
                              {archivoArchivoPendientes == "Si" ? (
                                <>
                                {/* {ArchivoPendientes} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoArchivoPendientes(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.ArchivoPendientes} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoArchivoPendientes();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>

                                <tr>
                  <td>BL Revalidado</td>
                  <td>
                            <>
                              {archivoBLRevalidado == "Si" ? (
                                <>
                                {/* {BLRevalidado} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoBLRevalidado(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.BLRevalidado} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoBLRevalidado();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>

                                <tr>
                  <td>Clasificado</td>
                  <td>
                            <>
                              {archivoClasificado == "Si" ? (
                                <>
                                {/* {Clasificado} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoClasificado(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.Clasificado} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoClasificado();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>

                                <tr>
                  <td>Carta 3.1.8</td>
                  <td>
                            <>
                              {archivoCarta318 == "Si" ? (
                                <>
                                {/* {Carta318} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoCarta318(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.Carta318} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoCarta318();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>

                                <tr>
                  <td>Proforma Pedimento</td>
                  <td>
                            <>
                              {archivoProformaPedimento == "Si" ? (
                                <>
                                {/* {ProformaPedimento} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoProformaPedimento(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.ProformaPedimento} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoProformaPedimento();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>


                <tr>
                  <td>Packing</td>
                  <td>
                            <>
                              {packing == "Si" ? (
                                <>
                                {/* {packing} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoPacking(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {a.packing} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoPacking();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>Ficha Tecnica</td>
                  <td>
                            <>
                              {fichaTecnicaArchivo == "Si" ? (
                                <>
                                {/* {fichaTencnica} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoFichaTecnica(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {fichaTencnica} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoFichaTecnica();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>BL</td>
                  <td>
                            <>
                              {blArchivo == "Si" ? (
                                <>
                                {/* {bl} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoBL(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {bl} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(idControlCalidad)
                                    toggleSubirFotoBL();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>Invoice</td>
                  <td>
                            <>
                              {invoice == "Si" ? (
                                <>
                                {/* {invoice} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoInvoice(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {invoice} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoInvoice();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>

                <tr>
                  <td>Cargos Locales</td>
                  <td>
                            <>
                              {cargosLocales == "Si" ? (
                                <>
                                {/* {cargosLocales} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoCargosLocales(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {cargosLocales} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoCargosLocales();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>Garantia</td>
                  <td>
                            <>
                              {garantia == "Si" ? (
                                <>
                                {/* {garantia} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoGarantia(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {garantia} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoGarantia();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>DODA</td>
                  <td>
                            <>
                              {DODA == "Si" ? (
                                <>
                                {/* {DODA} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoDODA(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {DODA} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoDODA();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>Boleta</td>
                  <td>
                            <>
                              {boleta == "Si" ? (
                                <>
                                {/* {boleta} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoBoleta(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {boleta} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoBoleta();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>Prealta</td>
                  <td>
                            <>
                              {prealta == "Si" ? (
                                <>
                                {/* {prealta} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoPrealta(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {prealta} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoPrealta();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
                <tr>
                  <td>EIR</td>
                  <td>
                            <>
                              {EIR == "Si" ? (
                                <>
                                {/* {EIR} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => jalaFotoEIR(idContenedor)}
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              ) : (
                                <>
                                {/* {EIR} */}
                                <Button
                                  color="info"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-camera"></i>
                                </Button>
                                </>
                              )}
                              {user.contenedoresCreate ? (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  onClick={(e) => {
                                    setIdContenedor(idContenedor);
                                    // setIdControlCalidad(a.idControlCalidad)
                                    toggleSubirFotoEIR();
                                  }}
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              ) : (
                                <Button
                                  color="success"
                                  id="Editar"
                                  size="sm"
                                  disabled
                                >
                                  <i class="fas fa-upload"></i>
                                </Button>
                              )}
                            </>
                          </td>
                </tr>
            </tbody>
        </Table>
      </ModalBody>
    </Modal>


<Modal
  isOpen={modalOpenPedimentos}
  toggle={closePedimentosModal}
  size="lg"
>
  <ModalHeader toggle={closePedimentosModal}>
    Pedimentos —{" "}
    {selectedContenedor?.contenedor ||
      selectedContenedor?.numeroInterno ||
      ""}
  </ModalHeader>

  <ModalBody>
    {(selectedContenedor?.pedimentos || []).length ? (
      <Table striped bordered size="sm" responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Número</th>
            <th>Fecha</th>
            <th>Observaciones</th>
            <th>Estatus</th>
          </tr>
        </thead>
        <tbody>
          {(selectedContenedor?.pedimentos || []).map((p, idx) => (
            <tr key={p?._id || idx}>
              <td>{idx + 1}</td>
              <td>{p?.numero || ""}</td>
              <td>{p?.fecha || ""}</td>
              <td style={{ whiteSpace: "pre-wrap" }}>
                {p?.observaciones || ""}
              </td>
              <td>
                {p?.is_active === "Si" ? (
                  <span className="badge bg-success">Vigente</span>
                ) : (
                  <span className="badge bg-secondary">Histórico</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <div className="text-muted">Este contenedor no tiene pedimentos aún.</div>
    )}

    <hr />

    <h6 className="mt-3">Agregar nuevo pedimento</h6>

    <Row className="align-items-center">
      <Col md={5} className="mb-2">
        <Input
          placeholder="Número de pedimento"
          value={nuevoPedimento}
          onChange={(e) => setNuevoPedimento(e.target.value)}
        />
      </Col>

      <Col md={5} className="mb-2">
        <Input
          placeholder="Observaciones (opcional)"
          value={obsPedimento}
          onChange={(e) => setObsPedimento(e.target.value)}
        />
      </Col>

      <Col md={2} className="mb-2">
        <Button
          color="success"
          block
          onClick={guardarPedimento}
          disabled={loadingPedimento || !nuevoPedimento.trim()}
          title="Agregar pedimento"
        >
          {loadingPedimento ? "Guardando..." : "Agregar"}
        </Button>
      </Col>
    </Row>
  </ModalBody>

  <ModalFooter>
    <Button color="secondary" onClick={closePedimentosModal}>
      Cerrar
    </Button>
  </ModalFooter>
</Modal>



      {loader}
    </>
  );
}

export default ListadoContenedores;

